import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  signal,
  ChangeDetectorRef,
} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService,
  ProjectService,
  TenantService,
} from '../../_services/index';

import {
  ClientContact,
  ClientITProfile,
  Company,
  NetworkDescriptionAndDiagram,
  ProjectControlItem,
  SystemInterconnection,
  SystemRolePrivilege,
  User,
} from '../../_models/index';

import {
  Access,
  ClientContactRole,
  CompanyType,
  DataDirection,
  Role,
} from '../../helpers/index';

import {
  AbstractControl, FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import * as _ from 'lodash';

import {saveAs as importedSaveAs} from 'file-saver';

import {LoginHelper} from '../../helpers';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {NameAndIdentifier} from '../../_models/nameAndIdentifier';
import {NameAndIdentifierTypeList} from '../../_models/nameAndIdentifierType';
import {SystemLocation} from '../../_models/systemLocation';
import {Device} from '../../_models/device';
import {OtherDesignatedContact} from '../../_models/otherDesignatedContact';
import {SystemSecurityPlanApproval} from '../../_models/systemSecurityPlanApproval';
import {SensitivityCategorization} from '../../_models/sensitivityCategorization';
import {ControlOrigination} from '../../_models/controlOrigination';
import {LeveragedAuthorization} from '../../_models/leveragedAuthorization';
import {PortProtocolService} from '../../_models/portProtocolService';
import {StandartAndGuidance} from '../../_models/standartAndGuidance';
import {LawAndRegulation} from '../../_models/lawAndRegulation';
import {RoleSensitivityLevel} from '../../_models/roleSensitivityLevel';
import {Constants} from '../../helpers/constants';
import {TenantPermissions} from '../../_models/tenantPermissions';
import {SelectControlItemComponent} from '../selectControlItem/select-control-item.component';
import {SelectProjectControlItemComponent} from '../selectProjectControlItem/select-project-control-item.component';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {InformationType} from "../../_models/informationType";
import {SeparationOfDuty} from "../../_models/separationOfDuty";
import {SeparationOfDutyRole} from "../../_models/separationOfDutyRole";
import {AuthorizedService} from "../../_models/authorizedService";
import {ExternalSystem} from "../../_models/externalSystem";
import {DictionaryService} from "../../_services/dictionary.service";
import {DictionaryItem} from "../../_models/dictionaryItem";
import {InspectionProfileService} from "../../_services/inspectionProfile.service";
import {InspectionResultsPopupComponent} from "../inspectionResultsPopup/inspectionResultsPopup.component";
import {SystemUser} from "../../_models/systemUser";
import {SeparatedUser} from "../../_models/separatedUser";
import {AddSignatureComponent} from "../addSignature/addSignature.component";
import { Integration } from '../../_models/integration';
import { IntegrationsService } from '../../_services';
import {SelectDiagramPositionComponent} from "../selectDiagramPosition/selectDiagramPosition.component";

@Component({
  standalone: false,
  selector: 'it-profile',
  templateUrl: 'it.profile.component.html',
  styleUrls: ['./it.profile.component.scss'],
  providers: [DialogService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItProfileComponent implements OnInit, OnDestroy {
  pageTitle;
  loading = false;
  currentUser: User;
  clientProfileId: number;
  formGroup: FormGroup;
  colorForm = new FormControl('#00000');
  displayRoleDialog: boolean;
  selectDialogRef: DynamicDialogRef | undefined;
  cols: any[];
  api: string;

  roles: SystemRolePrivilege[] = [];
  role: SystemRolePrivilege = new SystemRolePrivilege();
  selectedRole: SystemRolePrivilege;
  newRole: boolean;

  displaySystemUserDialog: boolean;
  systemUsers: SystemUser[] = [];
  systemUser: SystemUser = new SystemUser();
  selectedSystemUser: SystemUser;
  newSystemUser: boolean;

  displaySeparatedUserDialog: boolean;
  integrations: Integration[] = [];
  separatedUserIntegrations: number[] = [];

  displaySeparatedUserIntegrationsDialog: boolean;
  separatedUsers: SeparatedUser[] = [];
  separatedUser: SeparatedUser = new SeparatedUser();
  selectedSeparatedUser: SeparatedUser;
  newSeparatedUser: boolean;

  itProfiles: ClientITProfile[];
  accessList: any[];

  detailedNetworkDiagram1: string;
  detailedNetworkDiagram2: string;
  detailedNetworkDiagram3: string;
  lowMediumHigh = {0: 'Low (L)', 1: 'Moderate (M)', 2: 'High (H)'};
  isMaster: boolean = false;
  returnToProjectId: any = null;
  quiz: any = {quizData: {steps: []}};

  interconnections: SystemInterconnection[] = [];
  interconnection: SystemInterconnection = new SystemInterconnection();
  selectedInterconnection: SystemInterconnection;
  newInterconnection: boolean;
  displayInterconnectionDialog: boolean;
  dataDirectionList: any[];

  displayNameAndIdentifierDialog: boolean;
  newNameAndIdentifier: boolean;
  nameAndIdentifier: NameAndIdentifier;
  selectedNameAndIdentifier: NameAndIdentifier;

  displaySystemLocationDialog: boolean;
  newSystemLocation: boolean;
  systemLocation: SystemLocation;
  selectedSystemLocation: SystemLocation;

  displayDeviceDialog: boolean;
  newDevice: boolean;
  device: Device;
  selectedDevice: Device;

  displayOtherDesignatedContactDialog: boolean;
  newOtherDesignatedContact: boolean;
  otherDesignatedContact: OtherDesignatedContact;
  selectedOtherDesignatedContact: OtherDesignatedContact;

  displaySystemSecurityPlanApprovalDialog: boolean;
  newSystemSecurityPlanApproval: boolean;
  selectedSystemSecurityPlanApproval: SystemSecurityPlanApproval;
  systemSecurityPlanApproval: SystemSecurityPlanApproval;

  displaySensitivityCategorizationDialog: boolean;
  newSensitivityCategorization: boolean;
  selectedSensitivityCategorization: SensitivityCategorization;
  sensitivityCategorization: SensitivityCategorization;

  displayLeveragedAuthorizationDialog: boolean;
  newLeveragedAuthorization: boolean;
  selectedLeveragedAuthorization: LeveragedAuthorization;
  leveragedAuthorization: LeveragedAuthorization;

  displayPortProtocolServiceDialog: boolean;
  newPortProtocolService: boolean;
  selectedPortProtocolService: PortProtocolService;
  portProtocolService: PortProtocolService;

  displayLawAndRegulationDialog: boolean;
  newLawAndRegulation: boolean;
  selectedLawAndRegulation: LawAndRegulation;
  lawAndRegulation: LawAndRegulation;

  displayStandartAndGuidanceDialog: boolean;
  newStandartAndGuidance: boolean;
  selectedStandartAndGuidance: StandartAndGuidance;
  standartAndGuidance: StandartAndGuidance;

  displayInformationTypeDialog: boolean;
  newInformationType: boolean;
  selectedInformationType: InformationType;
  informationType: InformationType;

  displaySeparationOfDutyDialog: boolean;
  newSeparationOfDuty: boolean;
  selectedSeparationOfDuty: SeparationOfDuty;
  separationOfDuty: SeparationOfDuty;

  displaySeparationOfDutyRoleDialog: boolean;
  newSeparationOfDutyRole: boolean;
  selectedSeparationOfDutyRole: SeparationOfDutyRole;
  separationOfDutyRole: SeparationOfDutyRole;

  displayAuthorizedServiceDialog: boolean;
  newAuthorizedService: boolean;
  selectedAuthorizedService: AuthorizedService;
  authorizedService: AuthorizedService;

  displayExternalSystemDialog: boolean;
  newExternalSystem: boolean;
  selectedExternalSystem: ExternalSystem;
  externalSystem: ExternalSystem;

  serverDiagram: string;
  systemBoundaryDiagram: string;
  dataFlowDiagram: string;
  itProfile: ClientITProfile;
  detailNetworkDiagram: File[];

  namesAndIdentifiers: NameAndIdentifier[];
  systemLocations: SystemLocation[];
  devices: Device[];
  projectControlItems: ProjectControlItem[];
  otherDesignatedContacts: OtherDesignatedContact[];
  sensitivityCategorizations: SensitivityCategorization[];
  controlOriginations: ControlOrigination[];
  leveragedAuthorizations: LeveragedAuthorization[];
  portProtocolServices: PortProtocolService[];
  standartAndGuidances: StandartAndGuidance[];
  informationTypes: InformationType[];
  separationOfDuties: SeparationOfDuty[];
  separationOfDutyRoles: SeparationOfDutyRole[];
  lawAndRegulations: LawAndRegulation[];
  systemSecurityPlanApprovals: SystemSecurityPlanApproval[];
  authorizedServices: AuthorizedService[];
  externalSystems: ExternalSystem[];
  primaryColor = '';
  primaryTextColor = '';
  secondaryColor = '';
  secondaryTextColor = '';
  tertiaryColor = '';
  tertiaryTextColor = '';
  projects = [];
  mappedProjects = [];
  window = window;
  token: string;
  tenantPermissions: TenantPermissions = {};
  rulesOfBehaviour: string;
  contingencyPlan: string;
  configurationManagementPlan: string;
  incidentResponsePlan: string;
  seprationOfDutiesMatrix: string;
  relatedAcronyms?: string;
  policiesAndProcedures?: string;
  userGuide?: string;
  controlImplementationSummary?: string;
  integratedInventoryWorkbook?: string;
  continuousMonitoringPlan?: string;
  supplyChainRiskManagementPlan?: string;
  cryptographicModulesTable?: string;
  csoName: string;
  csoCategorization: string;
  separationOfDutiesVisible: boolean;
  deploymentType: string;
  primaryOS: string;
  identityManagement: string;
  firewallProduct: string;
  configManagementProduct: string;
  devLanguage: string;
  securityTools: string;
  otherTech1: string;
  groupedServices: any = {};
  constants = Constants;
  diagrams: any[] = [];

  readonly panelOpenState = signal(false);

  public nameAndIdentifierTypes = NameAndIdentifierTypeList;

  namesAndIdentifiersCols: any[] = [
    {field: 'systemName', header: 'System or Vendor Name', width: '20%'},
    {
      field: 'systemNameAbbreviation',
      header: 'System Name Abbreviation',
      width: '12em',
    },
    {field: 'type', header: 'Type', width: '12em'},
    {field: 'description', header: 'Description'},
  ];

  systemLocationsCols: any[] = [
    {field: 'subSystemName', header: 'Sub-System Name'},
    {field: 'systemType', header: 'System Type'},
    {field: 'responsibility', header: 'Responsibility'},
    {field: 'location', header: 'Location'},
  ];

  devicesCols: any[] = [];

  otherDesignatedContactsCols: any[] = [
    {field: 'role', header: 'Role'},
    {field: 'name', header: 'Name'},
    {field: 'title', header: 'Title'},
    {field: 'company', header: 'Company'},
    {field: 'nothing', header: 'Contact Information'},
  ];

  systemSecurityPlanApprovalCols: any[] = [
    {field: 'name', header: 'Name'},
    {field: 'date', header: 'Date'},
    {field: 'title', header: 'Title'},
    {field: 'providerName', header: 'Cloud Service Provider'},
  ];

  sensitivityCategorizationCols: any[] = [
    {
      field: 'informationType',
      header:
        'Information Type (Use only information types from NIST SP 800-60, Volumes I and II as amended)',
    },
    {
      field: 'identifier',
      header: 'NIST 800-60 identifier for Associated Information Type',
    },
    {field: 'confidentiality', header: 'Confidentiality'},
    {field: 'integrity', header: 'Integrity'},
    {field: 'availability', header: 'Availability'},
  ];

  leveragedAuthorizationCols: any[] = [
    {field: 'name', header: 'Leveraged Information System Name'},
    {field: 'owner', header: 'Leveraged Service Provider Owner'},
    {field: 'date', header: 'Date Granted'},
    {field: 'fedramp_identifier', header: 'FedRAMP Identifier'},
  ];

  portProtocolServiceCols: any[] = [
    {field: 'ports', header: 'Ports (TCP/UDP)'},
    {field: 'protocols', header: 'Protocols'},
    {field: 'services', header: 'Services'},
    {field: 'reference', header: 'Reference #'},
    {field: 'purpose', header: 'Purpose'},
    {field: 'usedBy', header: 'Used By'},
  ];

  lawAndRegulationCols: any[] = [
    {field: 'identificationNumber', header: 'Identification Number'},
    {field: 'title', header: 'Title'},
    {field: 'date', header: 'Date'},
    {field: 'link', header: 'Link'},
  ];

  standartAndGuidanceCols: any[] = [
    {field: 'identificationNumber', header: 'Identification Number'},
    {field: 'title', header: 'Title'},
    {field: 'date', header: 'Date'},
    {field: 'link', header: 'Link'},
  ];

  informationTypeCols: any[] = [
    {field: 'name', header: 'Name'},
    {field: 'recommendedConfidentialityLevel', header: 'Recommended Confidentiality Level'},
    {field: 'recommendedIntegrityLevel', header: 'Recommended Integrity Level'},
    {field: 'recommendedAvailabilityLevel', header: 'Recommended Availability Level'},
    {field: 'selectedConfidentialityLevel', header: 'Selected Confidentiality Level'},
    {field: 'selectedIntegrityLevel', header: 'Selected Integrity Level'},
    {field: 'selectedAvailabilityLevel', header: 'Selected Availability Level'},
    {field: 'statement', header: 'Statement'},
  ];

  rolesCols: any[] = [
    {field: 'role', header: 'Role'},
    {field: 'isInternal', header: 'Is Internal'},
    {field: 'access', header: 'Access', width: '12em'},
    {field: 'sensitivityLevel', header: 'Sensitivity Level'},
    {field: 'authorizedPrivileges', header: 'Authorized Privileges'},
    {
      field: 'authorizedFunctionsPerformed',
      header: 'Authorized Functions Performed',
    },
  ];

  systemUsersCols: any[] = [
    {field: 'name', header: 'Name'},
    {field: 'role', header: 'Role'},
    {field: 'reviewedDate', header: 'Reviewed', width: '12em'},
    {field: 'lastLoginDate', header: 'Last Login', width: '12em'},
  ];

  separatedUsersCols: any[] = [
    {field: 'name', header: 'Name'},
    {field: 'separationDate', header: 'SeparationDate'},
    {field: 'accessRevoked', header: 'Access Revoked', width: '12em'},
    {field: 'revokationDate', header: 'Revocation Date', width: '12em'},
    {field: 'signedDate', header: 'Reviewed', width: '12em'},
  ];

  authorizedServiceCols: any[] = [
    {field: 'name', header: 'CSP/CSO Name (Name on FedRAMP Marketplace)'},
    {
      field: 'service',
      header: 'CSO Service (Names of services and features - services from a single CSO can be all listed in one cell)'
    },
    {field: 'authorizationType', header: 'Authorization Type (JAB or Agency)', width: '12em'},
    {field: 'fedRampPackageId', header: 'FedRAMP Package ID #'},
    {field: 'nature', header: 'Nature of Agreement'},
    {field: 'impactLevel', header: 'Impact Level'},
    {field: 'dataTypes', header: 'Data Types'},
    {field: 'users', header: 'Authorized Users/Authentication'},
  ];

  externalSystemCols: any[] = [
    {field: 'number', header: '#'},
    {field: 'name', header: 'System/ Service/ API/CLI Name (Non-FedRAMP Cloud Services)'},
    {field: 'connectionDetails', header: 'Connection Details'},
    {field: 'nature', header: 'Nature of Agreement'},
    {field: 'isSupported', header: 'Still Supported? Y or N'},
    {field: 'dataTypes', header: 'Data Types'},
    {field: 'dataCategorization', header: 'Data Categorization'},
    {field: 'users', header: 'Authorized Users/ Authentication'},
    {field: 'otherPrograms', header: 'Other Compliance Programs'},
    {field: 'description', header: 'Description'},
    {field: 'hostingEnvironment', header: 'Hosting Environment'},
    {field: 'riskImpactMitigation', header: 'Risk/Impact/Mitigation'},
  ];

  interconnectionsCols: any[] = [
    {field: 'addressAndInterface', header: 'SP* IP Address and Interface'},
    {
      field: 'externalOrgName',
      header: 'External Organization Name and IP Address of System',
    },
    {
      field: 'externalPointOfContact',
      header: 'External Point of Contact and Phone Number',
    },
    {
      field: 'connectionSecurity',
      header:
        'Connection Security (IPSec VPN, SSL, Certificates, Secure File Tranfer, etc.)',
    },
    {field: 'dataDirection', header: 'Data Direction', width: '19em'},
    {
      field: 'informationBeingTransmitted',
      header: 'Information Being Transmitted',
    },
    {field: 'portOrCircuitNumbers', header: 'Port or Circuit Numbers'},
  ];

  /** Returns a FormArray with the name 'formArray'. */
  get formArray(): AbstractControl | null {
    return this.formGroup.get('formArray');
  }

  topics: DictionaryItem[];

  constructor(
    public dialog: MatDialog,
    public dialogService: DialogService,
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public dictionaryService: DictionaryService,
    public _formBuilder: FormBuilder,
    private clientProfileService: ClientProfileService,
    public projectsService: ProjectService,
    public fileBlobService: FileBlobService,
    public inspectionProfileService: InspectionProfileService,
    public tenantService: TenantService,
    public alertService: AlertService,
    private cdRef: ChangeDetectorRef,
    public integrationsService: IntegrationsService,
  ) {
    this.clientProfileService.getPublicSettings(LoginHelper.getTenantName()).subscribe(s => this.pageTitle = s.menuLabels['System'] || 'Environment');
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.api = window.location.origin || Constants.DefaultApiHost;
    this.token = LoginHelper.getFileToken();
    this.isMaster = LoginHelper.getTenantName() === Constants.RiskSpongeMaster;
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.tenantService.getCurrent().subscribe((p) => {
      this.tenantPermissions = p;
    });

    this.projectsService.getAllShort().subscribe((p) => {
      this.projects = p;
      if (this.itProfile) {
        this.setReturnToProjectId();
      }
    });

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.formGroup = this._formBuilder.group({
      formArray: this._formBuilder.array([
        this._formBuilder.group({
          ownersSectionVisible: [true],
          ownersSectionTitle: ['SYSTEM OWNER'],
          name: ['', Validators.required],
          systemOwnerFullNameFormCtrl: ['', Validators.required],
          systemOwnerTitleFormCtrl: ['', Validators.required],
          systemOwnerCompanyFormCtrl: ['', Validators.required],
          systemOwnerAddressFormCtrl: ['', Validators.required],
          systemOwnerPhoneFormCtrl: ['', Validators.required],
          systemOwnerEmailFormCtrl: ['', Validators.required],

          securityPointFullNameFormCtrl: ['', Validators.required],
          securityPointTitleFormCtrl: ['', Validators.required],
          securityPointCompanyFormCtrl: ['', Validators.required],
          securityPointAddressFormCtrl: ['', Validators.required],
          securityPointPhoneFormCtrl: ['', Validators.required],
          securityPointEmailFormCtrl: ['', Validators.required],

          securityOfficerFullNameFormCtrl: ['', Validators.required],
          securityOfficerTitleFormCtrl: ['', Validators.required],
          securityOfficerCompanyFormCtrl: ['', Validators.required],
          securityOfficerAddressFormCtrl: ['', Validators.required],
          securityOfficerPhoneFormCtrl: ['', Validators.required],
          securityOfficerEmailFormCtrl: ['', Validators.required],
        }),
        this._formBuilder.group({
          introSectionVisible: [true],
          introSectionTitle: [''],
          generalPurposeFormCtrl: ['', Validators.required],
          fedRampApplicationNumber: [''],
          systemName: ['', Validators.required],
          systemNameAbbreviation: [''],
          introduction: ['', Validators.required],
        }),
        this._formBuilder.group({
          namesSectionVisible: [true],
          namesSectionTitle: [''],
          systemName: ['', Validators.required],
          systemNameAbbreviation: ['', Validators.required],
          type: [0, Validators.required],
          description: ['', Validators.required],
        }),
        this._formBuilder.group({
          locationSectionVisible: [true],
          locationSectionTitle: [''],
          servicesProjectId: [null],
          subSystemName: ['', Validators.required],
          responsibility: ['', Validators.required],
          location: ['', Validators.required],
          systemType: ['', Validators.required],
          deviceName: [''],
          type: [''],
          manufacturer: [''],
          model: [''],
          serialNumber: [''],
          ip: [''],
          mac: [''],
          puid: [''],
          owner: [''],
          deviceLocation: [''],
          devicesSectionVisible: [true],
        }),
        this._formBuilder.group({
          typesSectionVisible: [true],
          typesSectionTitle: [''],
          typesOfInformationFormCtrl: ['', Validators.required],
        }),
        this._formBuilder.group({
          boundarySectionVisible: [true],
          boundarySectionTitle: [''],
          systemBoundaryPreDescriptionFormCtrl: ['', Validators.required],
          systemBoundaryDescriptionFormCtrl: ['', Validators.required],
          dataFlowDescription: ['', Validators.required],
          systemEnvironmentAndInventory: ['', Validators.required],
        }),
        this._formBuilder.group({
          authorizedFunctionsPerformedFormChildCtrl: [''],
          accessFormChildCtrl: [''],
          roleFormChildCtrl: [''],
          isInternal: [false],
          sensitivityLevel: [0],
          authorizedPrivileges: [''],
        }),
        this._formBuilder.group({
          environmentSectionVisible: [true],
          environmentSectionTitle: [''],
          systemEnvironmentDescriptionFormCtrl: ['', Validators.required],
          serverDescriptionsFormCtrl: ['', Validators.required],
        }),
        this._formBuilder.group({
          networkSectionVisible: [true],
          networkDescriptionFormCtrl1: [''],
          networkDescriptionFormCtrl2: [''],
          networkDescriptionFormCtrl3: [''],
        }),
        this._formBuilder.group({
          interconnectionSectionVisible: [true],
          interconnectionSectionTitle: [''],
        }),
        this._formBuilder.group({
          role: ['', Validators.required],
          name: ['', Validators.required],
          title: ['', Validators.required],
          company: ['', Validators.required],
          address: ['', Validators.required],
          phone: ['', Validators.required],
          email: ['', Validators.required],
        }),
        this._formBuilder.group({
          author: [''],
          versionOfSsp: [''],
          sspCompanyName: [''],
          description: [''],
          isFedRamp: [false],
          includePolicies: [false],
          includeOwnerNames: [false],
          includeResponsibility: [false],
          includeSubitems: [false],
          primaryColor: [''],
          primaryTextColor: [''],
          secondaryColor: [''],
          secondaryTextColor: [''],
          tertiaryColor: [''],
          tertiaryTextColor: [''],
          date: [new Date()],
        }),
        this._formBuilder.group({}),
        this._formBuilder.group({
          name: ['', Validators.required],
          date: ['', Validators.required],
          title: ['', Validators.required],
          providerName: ['', Validators.required],
        }),
        this._formBuilder.group({
          systemSensivityLevel: [0, Validators.required],
          confidentiality: [0, Validators.required],
          integrity: [0, Validators.required],
          availability: [0, Validators.required],
          abbreviationCategorization: [0, Validators.required],
          isSystemStatusOperational: [false, Validators.required],
          isSystemStatusUnderDevelopment: [false, Validators.required],
          isSystemStatusMajorModification: [false, Validators.required],
          isSystemStatusOther: [false, Validators.required],
          systemStatusOtherExplanation: ['', Validators.required],
          isSoftwareLayer: [false, Validators.required],
          isPlatformLayer: [false, Validators.required],
          isInfrastructureLayer: [false, Validators.required],
          isOtherLayer: [false, Validators.required],
          otherLayer: ['', Validators.required],
          isPublicCloud: [false, Validators.required],
          isPrivateCloud: [false, Validators.required],
          isGovernmentCloud: [false, Validators.required],
          isHybridCloud: [false, Validators.required],
          hybridCloud: ['', Validators.required],
          identityAssuranceLevel: [1, Validators.required],
          authenticatorAssuranceLevel: [1, Validators.required],
          federationAssuranceLevel: [1, Validators.required],
          isaSharesPii: [false, Validators.required],
          isaSharesPiiPublic: [false, Validators.required],
          piaPerformedForIsa: [false, Validators.required],
          isSorn: [false, Validators.required],
          sorn: ['', Validators.required],
        }),
        this._formBuilder.group({
          informationType: ['', Validators.required],
          identifier: ['', Validators.required],
          confidentiality: [0, Validators.required],
          integrity: [0, Validators.required],
          availability: [0, Validators.required],
        }),
        this._formBuilder.group({
          contactsSectionVisible: [true],
          contactsSectionTitle: ['OTHER DESIGNATED CONTACTS'],
        }),
        this._formBuilder.group({
          name: ['', Validators.required],
          owner: ['', Validators.required],
          date: ['', Validators.required],
          fedramp_identifier: ['', Validators.required],
        }),
        this._formBuilder.group({
          systemFunctionOrPurpose: ['', Validators.required],
          isFedRampAuthorizationPlanned: [false, Validators.required],
        }),
        this._formBuilder.group({
          rolesSectionVisible: [true],
          rolesSectionTitle: [''],
          internalCount: [''],
          externalCount: [''],
          internalNextYearCount: [''],
          externalNextYearCount: [''],
        }),
        this._formBuilder.group({
          ports: [''],
          protocols: [''],
          service: [''],
          purpose: [''],
          reference: [''],
          usedBy: [''],
        }),
        this._formBuilder.group({
          addressAndInterface: [''],
          externalOrgNameFormChildCtrl: [''],
          externalPointOfContactFormChildCtrl: [''],
          connectionSecurityFormChildCtrl: [''],
          dataDirectionFormChildCtrl: [''],
          informationBeingTransmittedFormChildCtrl: [''],
          portOrCircuitNumbersFormChildCtrl: [''],
        }),
        this._formBuilder.group({
          identificationNumber: '',
          title: '',
          date: new Date(),
          link: '',
        }),
        this._formBuilder.group({
          identificationNumber: [''],
          title: [''],
          date: [''],
          link: [''],
        }),
        this._formBuilder.group({
          authorizingOfficial: [''],
        }),
        this._formBuilder.group({
          rulesOfBehaviour: '',
          contingencyPlan: '',
          configurationManagementPlan: '',
          incidentResponsePlan: '',
          seprationOfDutiesMatrix: '',
          relatedAcronyms: '',
          policiesAndProcedures: '',
          isUserGuideUrl: false,
          userGuide: '',
          userGuideUrl: '',
          controlImplementationSummary: '',
          integratedInventoryWorkbook: '',
          continuousMonitoringPlan: '',
          supplyChainRiskManagementPlan: '',
          cryptographicModulesTable: '',
        }),
        this._formBuilder.group({
          csoName: '',
          csoAbbreviation: '',
          csoCategorization: '',
          cspName: '',
          cspAbbreviation: '',
          fedRampPackageId: '',
          serviceModel: '',
          digitalIdentityLevel: '',
          fipsLevel: '',
          operationalDate: '',
          deploymentModel: '',
          authorizationPath: '',
          separationOfDutiesVisible: true,
          digitalIdentityLevel1: true,
          digitalIdentityLevel2: true,
          digitalIdentityLevel3: true
        }),
        this._formBuilder.group({
          name: [''],
          recommendedConfidentialityLevel: [0],
          recommendedIntegrityLevel: [0],
          recommendedAvailabilityLevel: [0],
          selectedConfidentialityLevel: [0],
          selectedIntegrityLevel: [0],
          selectedAvailabilityLevel: [0],
          statement: [''],
        }),
        this._formBuilder.group({
          name: [''],
        }),
        this._formBuilder.group({
          name: [''],
        }),
        this._formBuilder.group({
          name: '',
          service: '',
          authorizationType: '',
          fedRampPackageId: '',
          nature: '',
          impactLevel: '',
          dataTypes: '',
          users: '',
        }),
        this._formBuilder.group({
          number: '',
          name: '',
          connectionDetails: '',
          nature: '',
          isSupported: false,
          dataTypes: '',
          dataCategorization: '',
          users: '',
          otherPrograms: '',
          description: '',
          hostingEnvironment: '',
          riskImpactMitigation: ''
        }),
        this._formBuilder.group({
          deploymentType: [''],
          primaryOS: [''],
          identityManagement: [''],
          firewallProduct: [''],
          configManagementProduct: [''],
          devLanguage: [''],
          securityTools: [''],
          otherTech1: [''],
          operatingSystemStatus: [''],
          databaseStatus: [''],
          fileStorageStatus: [''],
          containerScanningStatus: [''],
          architectureStatus: [''],
          devLanguageStatus: [''],
          configurationManagementStatus: [''],
          accessManagementStatus: [''],
          keyManagementStatus: [''],
          firewallStatus: [''],
          codeRepositoryStatus: [''],
          immutabilityStatus: [''],
          monitoringStatus: [''],
          codeScanningStatus: [''],
          applicationScanningStatus: [''],
          desktopSecurityStatus: [''],
          userAuthStatus: [''],
          loginSecurityStatus: [''],
          operatingSystemValue: [''],
          databaseValue: [''],
          fileStorageValue: [''],
          containerScanningValue: [''],
          architectureValue: [''],
          devLanguageValue: [''],
          configurationManagementValue: [''],
          accessManagementValue: [''],
          keyManagementValue: [''],
          firewallValue: [''],
          codeRepositoryValue: [''],
          immutabilityValue: [''],
          monitoringValue: [''],
          codeScanningValue: [''],
          applicationScanningValue: [''],
          desktopSecurityValue: [''],
          userAuthValue: [''],
          loginSecurityValue: [''],
          boundaryTechnologies: this._formBuilder.array([]),
          updateProjects: [false],
          updateProjectsIds: [[]]
        }),
        this._formBuilder.group({
          name: '',
          role: '',
          reviewedDate: null,
          lastLoginDate: null,
        }),
        this._formBuilder.group({
          name: '',
          separationDate: null,
          accessRevoked: false,
          revokationDate: null,
        }),
        ,
        this._formBuilder.group({
          separatedUserIntegrations:[]
        }),
      ])
    });

    this.dataDirectionList = [];
    for (let i = 1; i <= DataDirection.Both; i++) {
      this.dataDirectionList.push({
        label: DataDirection[i].toString(),
        value: i,
      });
    }
    //-----------------------------------

    this.dictionaryService.get(['Topic', 'Service']).subscribe(t => {
      this.topics = t.filter(i => i.dictionary == 'Topic');
      const services = t.filter(i => i.dictionary == 'Service');
      this.groupedServices = {};
      services.forEach(s => {
        this.groupedServices[s.securityTopic] = this.groupedServices[s.securityTopic] || [];
        this.groupedServices[s.securityTopic].push(s);
      });

      this.route.params.subscribe((p) => {
        this.clientProfileId = p['id'];
        console.log("this is p");
        console.log(p);
        console.log("route is uh " + this.route);
        this.loadProfiles();
      });

    });

    this.integrationsService.getAll().subscribe((integrations) => {
      if (!integrations) {
        console.error('No integrations received from service');
        return;
      }
      this.integrations = integrations;
    });
  }

  loadProfiles() {
    //if (!this.clientProfileId) this.clientProfileId = 1;
    this.clientProfileService
      .getClientProfiles(LoginHelper.getTenantName())
      .subscribe(
        (clientITProfiles: ClientITProfile[]) => {
          if (!clientITProfiles || clientITProfiles.length === 0) {
            this.alertService.error('No IT profiles available.');
            this.router.navigate(['/profiles']);
            return;
          }

          this.itProfiles = clientITProfiles;
          this.itProfile = clientITProfiles.find(
            (p) => p.clientITProfileId == this.clientProfileId
          );
          this.updateDeviceColumns();

          if (this.projects) {
            this.setReturnToProjectId();
          }
          if (!this.itProfile && this.itProfiles.length) {
            this.router.navigate([
              '/profiles',
              'itProfile',
              this.itProfiles[0].clientITProfileId,
            ]);
          } else {
            const selected = this.itProfiles.find(
              (p) => p.clientITProfileId == this.itProfile.clientITProfileId
            );
            selected.quizData.steps = selected.quizData.steps || [];
            selected.quizData.steps.map((step, stepId) => {
              const controls = this.formArray.get([12]) as any;
              controls.addControl(
                'customVisible' + stepId,
                new FormControl(false)
              );
              controls.addControl('customTitle' + stepId, new FormControl(''));
              step.items.map((item, itemId) => {
                if (item.type == 'question') {
                  if (item.multiple) {
                    item.answers.map((answer, answerId) => {
                      controls.addControl(
                        'r' + stepId + '_' + itemId + '_' + answerId,
                        new FormControl(false)
                      );
                    });
                  } else {
                    controls.addControl(
                      'r' + stepId + '_' + itemId,
                      new FormControl([false, Validators.required])
                    );
                  }
                }
              });
            });
            if (selected) {
              this.selectItProfile(selected);
            } else {
              if (this.itProfiles.length > 0) {
                this.selectItProfile(this.itProfiles[0]);
              } else {
                this.selectItProfile({});
              }
            }
          }
          this.cdRef.detectChanges();
        },
        (error) => {
          console.log(`Name: ${LoginHelper.getTenantName()} and id ${this.clientProfileId}`)
          console.error('Failed to load IT profiles:', error);
          this.alertService.error(
            'Failed to load IT profiles. Please try again later.'
          );
        }
      );
  }

  toggleProject(id, event) {
    const itStackGroup = this.formArray.get([32]) as FormGroup;
    const control = itStackGroup.controls.updateProjectsIds;
    if (event.checked) {
      control.setValue([...control.value, id]);
    } else {
      control.setValue(control.value.filter(v => v.projectId !== id));
    }
  }

  ngOnDestroy(): void {
    this.selectDialogRef?.close();
  }

  onItProfileChanged(event) {
    this.router.navigate(['/profiles/itProfile', event.value]);
  }

  createItProfile() {
    this.clientProfileService
      .updateClientProfile({name: 'IT Profile'})
      .subscribe((r) =>
        this.router.navigate([
          '/profiles/itProfile',
          r.clientITProfileId,
          'edit',
        ])
      );
  }

  copyItProfile(itProfile) {
    const quiz = JSON.parse(JSON.stringify(itProfile));
    quiz.name = 'Copy of ' + quiz.name;
    quiz.clientITProfileId = 0;
    (quiz.sensitivityCategorizations || []).forEach((c) => {
      c.sensitivityCategorizationId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.controlOriginations || []).forEach((c) => {
      c.controlOriginationId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.leveragedAuthorizations || []).forEach((c) => {
      c.leveragedAuthorizationId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.portProtocolServices || []).forEach((c) => {
      c.portProtocolServiceId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.standartAndGuidances || []).forEach((c) => {
      c.standartAndGuidanceId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.informationTypes || []).forEach(c => {
      c.informationTypeId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.separationOfDuties || []).forEach(c => {
      c.separationOfDutyId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.separationOfDutyRoles || []).forEach(c => {
      c.separationOfDutyRoleId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.lawAndRegulations || []).forEach(c => {
      c.lawAndRegulationId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.systemSecurityPlanApprovals || []).forEach((c) => {
      c.systemSecurityPlanApprovalId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.networkDescriptionsAndDiagrams || []).forEach((c) => {
      c.networkDescriptionAndDiagramId = 0;
    });
    (quiz.systemInterconnections || []).forEach((c) => {
      c.systemInterconnectionId = 0;
    });
    (quiz.systemRolePrivileges || []).forEach((c) => {
      c.systemRolePrivilegeId = 0;
    });
    (quiz.systemUsers || []).forEach((c) => {
      c.systemUserId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.separatedUsers || []).forEach((c) => {
      c.separatedUserId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.nameAndIdentifiers || []).forEach((c) => {
      c.nameAndIdentifierId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.systemLocations || []).forEach((c) => {
      c.systemLocationId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.devices || []).forEach((c) => {
      c.deviceId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.otherDesignatedContacts || []).forEach((c) => {
      c.otherDesignatedContactId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.authorizedServices || []).forEach((c) => {
      c.authorizedServiceId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.externalSystems || []).forEach((c) => {
      c.externalSystemId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.systemOwnerClientContact || {}).clientContactId = 0;
    quiz.systemOwnerClientContactId = 0;
    (quiz.securityPointClientContact || {}).clientContactId = 0;
    quiz.securityPointClientContactId = 0;
    (quiz.securityOfficerClientContact || {}).clientContactId = 0;
    quiz.securityOfficerClientContactId = 0;
    quiz.quiz = JSON.stringify(quiz.quizData);
    this.clientProfileService.updateClientProfile(quiz).subscribe((p) => {
      this.router.navigate([
        '/profiles/itProfile',
        p.clientITProfileId,
        'edit',
      ]);
    });
  }

  selectItProfile(itProfile: ClientITProfile) {
    this.inspectionProfileService.getFindingsForItProfile(itProfile?.clientITProfileId || 0).subscribe(devicesWithFindings => {
      if (!itProfile) {
        itProfile = {
          networkDescriptionsAndDiagrams: [],
          systemInterconnections: [],
          systemRolePrivileges: [],
          systemUsers: [],
          separatedUsers: [],
          systemOwnerClientContact: {},
          nameAndIdentifiers: [],
          systemLocations: [],
          devices: [],
          otherDesignatedContacts: [],
          sensitivityCategorizations: [],
          controlOriginations: [],
          leveragedAuthorizations: [],
          portProtocolServices: [],
          standartAndGuidances: [],
          informationTypes: [],
          separationOfDuties: [],
          separationOfDutyRoles: [],
          lawAndRegulations: [],
          systemSecurityPlanApprovals: [],
          authorizedServices: [],
          externalSystems: [],
        };
      }

      this.quiz = itProfile || {};//TODO: come on
      this.quiz.quizData = this.quiz.quizData || {
        name: '',
        steps: [{name: '', items: []}],
      };
      this.quiz.quizData.steps = this.quiz.quizData.steps || [];
      this.itProfile = itProfile;
      this.updateDeviceColumns();

      const firstGroup = this.formArray.get([0]) as FormGroup;

      firstGroup.controls.ownersSectionVisible.setValue(
        itProfile.ownersSectionVisible
      );
      firstGroup.controls.ownersSectionTitle.setValue(
        itProfile.ownersSectionTitle || 'SYSTEM OWNER'
      );

      if (itProfile.systemOwnerClientContact != null) {
        firstGroup.controls.systemOwnerFullNameFormCtrl.setValue(
          itProfile.systemOwnerClientContact.fullName
        );
        firstGroup.controls.systemOwnerFullNameFormCtrl.setValue(
          itProfile.systemOwnerClientContact.fullName
        );
        firstGroup.controls.systemOwnerTitleFormCtrl.setValue(
          itProfile.systemOwnerClientContact.title
        );
        firstGroup.controls.systemOwnerCompanyFormCtrl.setValue(
          itProfile.systemOwnerClientContact.company
        );
        firstGroup.controls.systemOwnerAddressFormCtrl.setValue(
          itProfile.systemOwnerClientContact.address
        );
        firstGroup.controls.systemOwnerPhoneFormCtrl.setValue(
          itProfile.systemOwnerClientContact.phone
        );
        firstGroup.controls.systemOwnerEmailFormCtrl.setValue(
          itProfile.systemOwnerClientContact.email
        );
      }

      if (itProfile.securityPointClientContact != null) {
        firstGroup.controls.securityPointFullNameFormCtrl.setValue(
          itProfile.securityPointClientContact.fullName
        );
        firstGroup.controls.securityPointTitleFormCtrl.setValue(
          itProfile.securityPointClientContact.title
        );
        firstGroup.controls.securityPointCompanyFormCtrl.setValue(
          itProfile.securityPointClientContact.company
        );
        firstGroup.controls.securityPointAddressFormCtrl.setValue(
          itProfile.securityPointClientContact.address
        );
        firstGroup.controls.securityPointPhoneFormCtrl.setValue(
          itProfile.securityPointClientContact.phone
        );
        firstGroup.controls.securityPointEmailFormCtrl.setValue(
          itProfile.securityPointClientContact.email
        );
      }

      if (itProfile.securityOfficerClientContact != null) {
        firstGroup.controls.securityOfficerFullNameFormCtrl.setValue(
          itProfile.securityOfficerClientContact.fullName
        );
        firstGroup.controls.securityOfficerTitleFormCtrl.setValue(
          itProfile.securityOfficerClientContact.title
        );
        firstGroup.controls.securityOfficerCompanyFormCtrl.setValue(
          itProfile.securityOfficerClientContact.company
        );
        firstGroup.controls.securityOfficerAddressFormCtrl.setValue(
          itProfile.securityOfficerClientContact.address
        );
        firstGroup.controls.securityOfficerPhoneFormCtrl.setValue(
          itProfile.securityOfficerClientContact.phone
        );
        firstGroup.controls.securityOfficerEmailFormCtrl.setValue(
          itProfile.securityOfficerClientContact.email
        );
      }

      const introGroup = this.formArray.get([1]) as FormGroup;
      introGroup.controls.introSectionVisible.setValue(
        itProfile.introSectionVisible
      );
      introGroup.controls.introSectionTitle.setValue(
        itProfile.introSectionTitle || 'INTRODUCTION'
      );
      introGroup.controls.generalPurposeFormCtrl.setValue(
        itProfile.generalPurpose
      );
      introGroup.controls.fedRampApplicationNumber.setValue(
        itProfile.fedRampApplicationNumber
      );
      introGroup.controls.systemName.setValue(itProfile.systemName);
      introGroup.controls.systemNameAbbreviation.setValue(
        itProfile.systemNameAbbreviation
      );
      introGroup.controls.introduction.setValue(itProfile.introduction);

      const namesGroup = this.formArray.get([2]) as FormGroup;
      namesGroup.controls.namesSectionVisible.setValue(
        itProfile.namesSectionVisible
      );
      namesGroup.controls.namesSectionTitle.setValue(
        itProfile.namesSectionTitle || 'NAMES/UNIQUE IDENTIFIERS'
      );

      const locationGroup = this.formArray.get([3]) as FormGroup;
      locationGroup.controls.locationSectionVisible.setValue(
        itProfile.locationSectionVisible
      );
      locationGroup.controls.devicesSectionVisible.setValue(
        itProfile.devicesSectionVisible
      );
      locationGroup.controls.locationSectionTitle.setValue(
        itProfile.locationSectionTitle || 'SUB-SYSTEMS & SERVICES'
      );

      const typesOfInformationGroup = this.formArray.get([4]) as FormGroup;
      typesOfInformationGroup.controls.typesSectionVisible.setValue(
        itProfile.typesSectionVisible
      );
      typesOfInformationGroup.controls.typesSectionTitle.setValue(
        itProfile.typesSectionTitle || 'INFORMATION TYPES'
      );
      typesOfInformationGroup.controls.typesOfInformationFormCtrl.setValue(
        itProfile.typesOfInformation
      );

      const generalPurposeGroup = this.formArray.get([5]) as FormGroup;
      generalPurposeGroup.controls.boundarySectionVisible.setValue(
        itProfile.boundarySectionVisible
      );
      generalPurposeGroup.controls.boundarySectionTitle.setValue(
        itProfile.boundarySectionTitle || 'SYSTEM BOUNDARY'
      );
      generalPurposeGroup.controls.systemBoundaryPreDescriptionFormCtrl.setValue(
        itProfile.systemBoundaryPreDescription
      );
      generalPurposeGroup.controls.systemBoundaryDescriptionFormCtrl.setValue(
        itProfile.systemBoundaryDescription
      );
      generalPurposeGroup.controls.dataFlowDescription.setValue(
        itProfile.dataFlowDescription
      );
      generalPurposeGroup.controls.systemEnvironmentAndInventory.setValue(
        itProfile.systemEnvironmentAndInventory
      );
      this.systemBoundaryDiagram = itProfile.systemBoundaryDiagram;
      this.dataFlowDiagram = itProfile.dataFlowDiagram;

      this.namesAndIdentifiers = itProfile.nameAndIdentifiers || [];
      this.systemLocations = itProfile.systemLocations || [];
      this.devices = itProfile.devices || [];
      devicesWithFindings?.forEach(f => {
        const current = this.devices.find(d => d.deviceId == f.deviceId);
        if (current) {
          current.findings = f.findings;
        }
      });
      this.otherDesignatedContacts = itProfile.otherDesignatedContacts || [];
      this.sensitivityCategorizations =
        itProfile.sensitivityCategorizations || [];
      this.controlOriginations = itProfile.controlOriginations || [];
      this.leveragedAuthorizations = itProfile.leveragedAuthorizations || [];
      this.portProtocolServices = itProfile.portProtocolServices || [];
      this.standartAndGuidances = itProfile.standartAndGuidances || [];
      this.informationTypes = itProfile.informationTypes || [];
      this.separationOfDuties = itProfile.separationOfDuties || [];
      this.separationOfDutyRoles = itProfile.separationOfDutyRoles || [];
      this.systemUsers = itProfile.systemUsers || [];
      this.separatedUsers = itProfile.separatedUsers || [];
      this.lawAndRegulations = itProfile.lawAndRegulations || [];
      this.systemSecurityPlanApprovals =
        itProfile.systemSecurityPlanApprovals || [];
      this.authorizedServices =
        itProfile.authorizedServices || [];
      this.externalSystems =
        itProfile.externalSystems || [];
      (this.separationOfDuties || []).forEach(c => {
        (<any>c).selectedRoles = {};
        (c.separationOfDutyRoles || []).forEach(r => {
          (<any>c).selectedRoles[r.separationOfDutyRoleId] = true;
        });
      });

      const authorizingOfficialGroup = this.formArray.get([24]) as FormGroup;
      authorizingOfficialGroup.controls.authorizingOfficial.setValue(
        itProfile.authorizingOfficial
      );

      this.roles = itProfile.systemRolePrivileges;
      this.systemUsers = itProfile.systemUsers || [];
      this.separatedUsers = itProfile.separatedUsers || [];

      const rolesGroup = this.formArray.get([19]) as FormGroup;
      rolesGroup.controls.rolesSectionVisible.setValue(
        itProfile.rolesSectionVisible
      );
      rolesGroup.controls.rolesSectionTitle.setValue(
        itProfile.rolesSectionTitle || 'USER TYPES'
      );
      rolesGroup.controls.internalCount.setValue(itProfile.internalCount);
      rolesGroup.controls.externalCount.setValue(itProfile.externalCount);
      rolesGroup.controls.internalNextYearCount.setValue(
        itProfile.internalNextYearCount
      );
      rolesGroup.controls.externalNextYearCount.setValue(
        itProfile.externalNextYearCount
      );

      this.rulesOfBehaviour = itProfile.rulesOfBehaviour;
      this.contingencyPlan = itProfile.contingencyPlan;
      this.configurationManagementPlan = itProfile.configurationManagementPlan;
      this.incidentResponsePlan = itProfile.incidentResponsePlan;
      this.seprationOfDutiesMatrix = itProfile.seperationOfDutiesMatrix;
      this.relatedAcronyms = itProfile.relatedAcronyms;
      this.policiesAndProcedures = itProfile.policiesAndProcedures;
      this.userGuide = itProfile.userGuide;
      this.controlImplementationSummary = itProfile.controlImplementationSummary;
      this.integratedInventoryWorkbook = itProfile.integratedInventoryWorkbook;
      this.continuousMonitoringPlan = itProfile.continuousMonitoringPlan;
      this.supplyChainRiskManagementPlan = itProfile.supplyChainRiskManagementPlan;
      this.cryptographicModulesTable = itProfile.cryptographicModulesTable;

      /*if (this.roles && this.roles.length > 0) {
        var role = this.roles[0];
        rolesGroup.controls.roleFormChildCtrl.setValue(role.role);
      }

      var roleAccess = null;
      if (role) {
        roleAccess = this.accessList.find(x => x.value == role.access);
      }

      rolesGroup.controls.accessFormChildCtrl.setValue(roleAccess != null ? roleAccess : {
        label: Access[0].toString(),
        value: 0
      });

      if (role) {
        rolesGroup.controls.authorizedFunctionsPerformedFormChildCtrl.setValue(role.authorizedFunctionsPerformed);
      }*/

      const systemEnvironmentDescriptionGroup = this.formArray.get([
        6 + 1,
      ]) as FormGroup;
      systemEnvironmentDescriptionGroup.controls.environmentSectionVisible.setValue(
        itProfile.environmentSectionVisible
      );
      systemEnvironmentDescriptionGroup.controls.environmentSectionTitle.setValue(
        itProfile.environmentSectionTitle || 'SYSTEM ENVIRONMENT'
      );
      systemEnvironmentDescriptionGroup.controls.systemEnvironmentDescriptionFormCtrl.setValue(
        itProfile.systemEnvironmentDescription
      );
      systemEnvironmentDescriptionGroup.controls.serverDescriptionsFormCtrl.setValue(
        itProfile.serverDescriptions
      );
      this.serverDiagram = itProfile.serverDiagram;

      const networkDescriptionGroup = this.formArray.get([8]) as FormGroup;
      networkDescriptionGroup.controls.networkSectionVisible.setValue(
        itProfile.networkSectionVisible
      );
      if (itProfile.networkDescriptionsAndDiagrams[0] != null) {
        networkDescriptionGroup.controls.networkDescriptionFormCtrl1.setValue(
          itProfile.networkDescriptionsAndDiagrams[0].networkDescription
        );
        this.detailedNetworkDiagram1 =
          itProfile.networkDescriptionsAndDiagrams[0].networkDiagram;
      }

      if (itProfile.networkDescriptionsAndDiagrams[1] != null) {
        networkDescriptionGroup.controls.networkDescriptionFormCtrl2.setValue(
          itProfile.networkDescriptionsAndDiagrams[1].networkDescription
        );
        this.detailedNetworkDiagram2 =
          itProfile.networkDescriptionsAndDiagrams[1].networkDiagram;
      }

      if (itProfile.networkDescriptionsAndDiagrams[2] != null) {
        networkDescriptionGroup.controls.networkDescriptionFormCtrl3.setValue(
          itProfile.networkDescriptionsAndDiagrams[2].networkDescription
        );
        this.detailedNetworkDiagram3 =
          itProfile.networkDescriptionsAndDiagrams[2].networkDiagram;
      }

      this.diagrams = itProfile.diagrams || [];
      itProfile.diagrams.forEach(d => {
        this.handleDiagram(d);
      })

      this.interconnections = itProfile.systemInterconnections;

      const interconnectionGroup = this.formArray.get([9]) as FormGroup;
      interconnectionGroup.controls.interconnectionSectionVisible.setValue(
        itProfile.interconnectionSectionVisible
      );
      interconnectionGroup.controls.interconnectionSectionTitle.setValue(
        itProfile.interconnectionSectionTitle || 'SYSTEM INTERCONNECTIONS'
      );

      const contactsGroup = this.formArray.get([16]) as FormGroup;
      contactsGroup.controls.contactsSectionVisible.setValue(
        itProfile.contactsSectionVisible
      );
      contactsGroup.controls.contactsSectionTitle.setValue(
        itProfile.contactsSectionTitle
      );

      const sspGroup = this.formArray.get([11]) as FormGroup;
      sspGroup.controls.date.setValue(itProfile.date);
      sspGroup.controls.description.setValue(itProfile.description);
      sspGroup.controls.versionOfSsp.setValue(itProfile.versionOfSsp);
      sspGroup.controls.sspCompanyName.setValue(itProfile.sspCompanyName);
      sspGroup.controls.isFedRamp.setValue(itProfile.isFedRamp);
      sspGroup.controls.includePolicies.setValue(itProfile.includePolicies);
      sspGroup.controls.includeOwnerNames.setValue(itProfile.includeOwnerNames);
      sspGroup.controls.includeResponsibility.setValue(
        itProfile.includeResponsibility
      );
      sspGroup.controls.includeSubitems.setValue(
        itProfile.includeSubitems
      );
      sspGroup.controls.primaryColor.setValue(itProfile.primaryColor);
      sspGroup.controls.primaryTextColor.setValue(itProfile.primaryTextColor);
      sspGroup.controls.secondaryColor.setValue(itProfile.secondaryColor);
      sspGroup.controls.secondaryTextColor.setValue(itProfile.secondaryTextColor);
      sspGroup.controls.tertiaryColor.setValue(itProfile.tertiaryColor);
      sspGroup.controls.tertiaryTextColor.setValue(itProfile.tertiaryTextColor);
      sspGroup.controls.author.setValue(itProfile.author);
      this.primaryColor = itProfile.primaryColor;
      this.primaryTextColor = itProfile.primaryTextColor;
      this.secondaryColor = itProfile.secondaryColor;
      this.secondaryTextColor = itProfile.secondaryTextColor;
      this.tertiaryColor = itProfile.tertiaryColor;
      this.tertiaryTextColor = itProfile.tertiaryTextColor;

      const controls = this.formArray.get([12]) as any;
      const answers = JSON.parse(this.itProfile.answers || '{}');
      this.quiz.quizData.steps.map((step, stepId) => {
        controls.controls['customVisible' + stepId].setValue(
          answers['customVisible' + stepId] || ''
        );
        controls.controls['customTitle' + stepId].setValue(
          answers['customTitle' + stepId] || ''
        );
        step.items.map((item, itemId) => {
          if (item.type == 'question' && answers['r' + stepId + '_' + itemId]) {
            if (item.multiple) {
              item.answers.map((answer, answerId) => {
                controls.controls[
                'r' + stepId + '_' + itemId + '_' + answerId
                  ].setValue(
                  (answers['r' + stepId + '_' + itemId] || []).indexOf(
                    answerId
                  ) >= 0
                );
              });
            } else {
              controls.controls['r' + stepId + '_' + itemId].setValue(
                answers['r' + stepId + '_' + itemId][0]
              );
            }
          }
        });
      });

      const fedRampGroup = this.formArray.get([14]) as FormGroup;
      fedRampGroup.controls.systemSensivityLevel.setValue(
        itProfile.systemSensivityLevel
      );
      fedRampGroup.controls.confidentiality.setValue(itProfile.confidentiality);
      fedRampGroup.controls.integrity.setValue(itProfile.integrity);
      fedRampGroup.controls.availability.setValue(itProfile.availability);
      fedRampGroup.controls.abbreviationCategorization.setValue(
        itProfile.abbreviationCategorization
      );
      fedRampGroup.controls.isSystemStatusOperational.setValue(
        itProfile.isSystemStatusOperational
      );
      fedRampGroup.controls.isSystemStatusUnderDevelopment.setValue(
        itProfile.isSystemStatusUnderDevelopment
      );
      fedRampGroup.controls.isSystemStatusMajorModification.setValue(
        itProfile.isSystemStatusMajorModification
      );
      fedRampGroup.controls.isSystemStatusOther.setValue(
        itProfile.isSystemStatusOther
      );
      fedRampGroup.controls.systemStatusOtherExplanation.setValue(
        itProfile.systemStatusOtherExplanation
      );
      fedRampGroup.controls.isSoftwareLayer.setValue(itProfile.isSoftwareLayer);
      fedRampGroup.controls.isPlatformLayer.setValue(itProfile.isPlatformLayer);
      fedRampGroup.controls.isInfrastructureLayer.setValue(
        itProfile.isInfrastructureLayer
      );
      fedRampGroup.controls.isOtherLayer.setValue(itProfile.isOtherLayer);
      fedRampGroup.controls.otherLayer.setValue(itProfile.otherLayer);
      fedRampGroup.controls.isPublicCloud.setValue(itProfile.isPublicCloud);
      fedRampGroup.controls.isPrivateCloud.setValue(itProfile.isPrivateCloud);
      fedRampGroup.controls.isGovernmentCloud.setValue(
        itProfile.isGovernmentCloud
      );
      fedRampGroup.controls.isHybridCloud.setValue(itProfile.isHybridCloud);
      fedRampGroup.controls.hybridCloud.setValue(itProfile.hybridCloud);
      fedRampGroup.controls.identityAssuranceLevel.setValue(
        itProfile.identityAssuranceLevel
      );
      fedRampGroup.controls.authenticatorAssuranceLevel.setValue(
        itProfile.authenticatorAssuranceLevel
      );
      fedRampGroup.controls.federationAssuranceLevel.setValue(
        itProfile.federationAssuranceLevel
      );
      fedRampGroup.controls.isaSharesPii.setValue(itProfile.isaSharesPii);
      fedRampGroup.controls.isaSharesPiiPublic.setValue(
        itProfile.isaSharesPiiPublic
      );
      fedRampGroup.controls.piaPerformedForIsa.setValue(
        itProfile.piaPerformedForIsa
      );
      fedRampGroup.controls.isSorn.setValue(itProfile.isSorn);
      fedRampGroup.controls.sorn.setValue(itProfile.sorn);

      const additionalInformationGroup = this.formArray.get([18]) as FormGroup;
      additionalInformationGroup.controls.systemFunctionOrPurpose.setValue(
        itProfile.systemFunctionOrPurpose
      );
      additionalInformationGroup.controls.isFedRampAuthorizationPlanned.setValue(
        itProfile.isFedRampAuthorizationPlanned
      );

      const appendicesGroup = this.formArray.get([25]) as FormGroup;
      appendicesGroup.controls.isUserGuideUrl.setValue(itProfile.isUserGuideUrl);
      appendicesGroup.controls.userGuideUrl.setValue(itProfile.userGuideUrl);

      const fedRamp5Group = this.formArray.get([26]) as FormGroup;
      fedRamp5Group.controls.csoName.setValue(itProfile.csoName);
      fedRamp5Group.controls.csoAbbreviation.setValue(itProfile.csoAbbreviation);
      fedRamp5Group.controls.csoCategorization.setValue(itProfile.csoCategorization);
      fedRamp5Group.controls.cspName.setValue(itProfile.cspName);
      fedRamp5Group.controls.cspAbbreviation.setValue(itProfile.cspAbbreviation);
      fedRamp5Group.controls.fedRampPackageId.setValue(itProfile.fedRampPackageId);
      fedRamp5Group.controls.serviceModel.setValue(itProfile.serviceModel);
      fedRamp5Group.controls.digitalIdentityLevel.setValue(itProfile.digitalIdentityLevel);
      fedRamp5Group.controls.fipsLevel.setValue(itProfile.fipsLevel);
      fedRamp5Group.controls.operationalDate.setValue(itProfile.operationalDate);
      fedRamp5Group.controls.deploymentModel.setValue(itProfile.deploymentModel);
      fedRamp5Group.controls.authorizationPath.setValue(itProfile.authorizationPath);
      fedRamp5Group.controls.separationOfDutiesVisible.setValue(itProfile.separationOfDutiesVisible);
      fedRamp5Group.controls.digitalIdentityLevel1.setValue(itProfile.digitalIdentityLevel1);
      fedRamp5Group.controls.digitalIdentityLevel2.setValue(itProfile.digitalIdentityLevel2);
      fedRamp5Group.controls.digitalIdentityLevel3.setValue(itProfile.digitalIdentityLevel3);

      const itStackGroup = this.formArray.get([32]) as FormGroup;
      itStackGroup.controls.deploymentType.setValue(itProfile.deploymentType);
      itStackGroup.controls.primaryOS.setValue(itProfile.primaryOS);
      itStackGroup.controls.identityManagement.setValue(itProfile.identityManagement);
      itStackGroup.controls.firewallProduct.setValue(itProfile.firewallProduct);
      itStackGroup.controls.configManagementProduct.setValue(itProfile.configManagementProduct);
      itStackGroup.controls.devLanguage.setValue(itProfile.devLanguage);
      itStackGroup.controls.securityTools.setValue(itProfile.securityTools);
      itStackGroup.controls.otherTech1.setValue(itProfile.otherTech1);
      itStackGroup.controls.operatingSystemStatus.setValue(itProfile.operatingSystemStatus);
      itStackGroup.controls.databaseStatus.setValue(itProfile.databaseStatus);
      itStackGroup.controls.fileStorageStatus.setValue(itProfile.fileStorageStatus);
      itStackGroup.controls.containerScanningStatus.setValue(itProfile.containerScanningStatus);
      itStackGroup.controls.architectureStatus.setValue(itProfile.architectureStatus);
      itStackGroup.controls.devLanguageStatus.setValue(itProfile.devLanguageStatus);
      itStackGroup.controls.configurationManagementStatus.setValue(itProfile.configurationManagementStatus);
      itStackGroup.controls.accessManagementStatus.setValue(itProfile.accessManagementStatus);
      itStackGroup.controls.keyManagementStatus.setValue(itProfile.keyManagementStatus);
      itStackGroup.controls.firewallStatus.setValue(itProfile.firewallStatus);
      itStackGroup.controls.codeRepositoryStatus.setValue(itProfile.codeRepositoryStatus);
      itStackGroup.controls.immutabilityStatus.setValue(itProfile.immutabilityStatus);
      itStackGroup.controls.monitoringStatus.setValue(itProfile.monitoringStatus);
      itStackGroup.controls.codeScanningStatus.setValue(itProfile.codeScanningStatus);
      itStackGroup.controls.applicationScanningStatus.setValue(itProfile.applicationScanningStatus);
      itStackGroup.controls.desktopSecurityStatus.setValue(itProfile.desktopSecurityStatus);
      itStackGroup.controls.userAuthStatus.setValue(itProfile.userAuthStatus);
      itStackGroup.controls.loginSecurityStatus.setValue(itProfile.loginSecurityStatus);
      itStackGroup.controls.operatingSystemValue.setValue(itProfile.operatingSystemValue);
      itStackGroup.controls.databaseValue.setValue(itProfile.databaseValue);
      itStackGroup.controls.fileStorageValue.setValue(itProfile.fileStorageValue);
      itStackGroup.controls.containerScanningValue.setValue(itProfile.containerScanningValue);
      itStackGroup.controls.architectureValue.setValue(itProfile.architectureValue);
      itStackGroup.controls.devLanguageValue.setValue(itProfile.devLanguageValue);
      itStackGroup.controls.configurationManagementValue.setValue(itProfile.configurationManagementValue);
      itStackGroup.controls.accessManagementValue.setValue(itProfile.accessManagementValue);
      itStackGroup.controls.keyManagementValue.setValue(itProfile.keyManagementValue);
      itStackGroup.controls.firewallValue.setValue(itProfile.firewallValue);
      itStackGroup.controls.codeRepositoryValue.setValue(itProfile.codeRepositoryValue);
      itStackGroup.controls.immutabilityValue.setValue(itProfile.immutabilityValue);
      itStackGroup.controls.monitoringValue.setValue(itProfile.monitoringValue);
      itStackGroup.controls.codeScanningValue.setValue(itProfile.codeScanningValue);
      itStackGroup.controls.applicationScanningValue.setValue(itProfile.applicationScanningValue);
      itStackGroup.controls.desktopSecurityValue.setValue(itProfile.desktopSecurityValue);
      itStackGroup.controls.userAuthValue.setValue(itProfile.userAuthValue);
      itStackGroup.controls.loginSecurityValue.setValue(itProfile.loginSecurityValue);
      this.topics?.forEach(s => {
        const item = itProfile.boundaryTechnologies?.find(t => t.topicId == s.itemId);
        (<FormArray>itStackGroup.controls.boundaryTechnologies).push(this._formBuilder.group({
          serviceId: [item?.serviceId || 0],
          topicId: [s.itemId],
          implementationStatus: [item?.implementationStatus || 0],
          responsibility: [item?.responsibility || '']
        }));
      })
    });
  }

  getAccessLabel(access) {
    return Access[access];
  }

  getDataDirection(dataDirection) {
    return DataDirection[dataDirection];
  }

  showDialogToAddNameAndIdentifier() {
    const formGroup = this.formArray.get([2]) as FormGroup;
    formGroup.reset({
      systemName: '',
      systemNameAbbreviation: '',
      type: '',
      description: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newNameAndIdentifier = true;
    this.nameAndIdentifier = new NameAndIdentifier();
    this.displayNameAndIdentifierDialog = true;
  }

  showDialogToAddSystemLocation() {
    const formGroup = this.formArray.get([3]) as FormGroup;
    formGroup.reset({
      subSystemName: '',
      responsibility: '',
      location: '',
      systemType: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newSystemLocation = true;
    this.systemLocation = new SystemLocation();
    this.displaySystemLocationDialog = true;
  }

  showDialogToAddDevice() {
    const formGroup = this.formArray.get([3]) as FormGroup;
    formGroup.reset({
      deviceName: '',
      type: '',
      manufacturer: '',
      model: '',
      serialNumber: '',
      ip: '',
      mac: '',
      puid: '',
      owner: '',
      location: '',
    });
    this.projectControlItems = [];
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newDevice = true;
    this.device = new Device();
    this.displayDeviceDialog = true;
  }

  showDialogToAddRole() {
    const formGroup = this.formArray.get([5 + 1]) as FormGroup;
    formGroup.reset({
      authorizedFunctionsPerformedFormChildCtrl: '',
      accessFormChildCtrl: '',
      roleFormChildCtrl: '',
      isInternal: false,
      sensitivityLevel: RoleSensitivityLevel.NA,
      authorizedPrivileges: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newRole = true;
    this.role = new SystemRolePrivilege();
    this.displayRoleDialog = true;
  }

  showDialogToAddSystemUser() {
    const formGroup = this.formArray.get([5 + 1]) as FormGroup;
    formGroup.reset({
      name: '',
      role: '',
      reviewedDate: null,
      lastLoginDate: null,
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newSystemUser = true;
    this.systemUser = new SystemUser();
    this.displaySystemUserDialog = true;
  }

  showDialogToAddSeparatedUser() {
    // TODO: what is this? Is there a better way to access the form instead of index???
    const formGroup = this.formArray.get([34]) as FormGroup;
    formGroup.reset({
      name: '',
      separationDate: null,
      accessRevoked: false,
      revokationDate: null
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newSeparatedUser = true;
    this.separatedUser = new SeparatedUser();

    const systemUsersGroup = this.formArray.get([34]) as FormGroup;

    this.displaySeparatedUserDialog = true;
  }

  showSeparatedUserIntegrationsDialog() {
    this.displaySeparatedUserIntegrationsDialog = true;
  }

  separatedUserIntegrationsChange(value: number, checked: boolean) {
    if (checked) {
      this.separatedUserIntegrations.push(value);
    } else {
      this.separatedUserIntegrations = this.separatedUserIntegrations.filter(v => v !== value);
    }
  }

  saveSeparatedUserIntegrations() {
    this.displaySeparatedUserIntegrationsDialog = false;
  }

  closeSeparatedUserIntegrationsDialog() {
    this.displaySeparatedUserIntegrationsDialog = false;
  }

  showDialogToAddInterconnection() {
    const formGroup = this.formArray.get([21]) as FormGroup;
    formGroup.reset({
      addressAndInterface: '',
      externalOrgNameFormChildCtrl: '',
      externalPointOfContactFormChildCtrl: '',
      connectionSecurityFormChildCtrl: '',
      dataDirectionFormChildCtrl: '',
      informationBeingTransmittedFormChildCtrl: '',
      portOrCircuitNumbersFormChildCtrl: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newInterconnection = true;
    this.interconnection = new SystemInterconnection();
    this.displayInterconnectionDialog = true;
  }

  showDialogToAddOtherDesignatedContact() {
    const formGroup = this.formArray.get([10]) as FormGroup;
    formGroup.reset({
      role: '',
      name: '',
      title: '',
      company: '',
      address: '',
      phone: '',
      email: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newOtherDesignatedContact = true;
    this.otherDesignatedContact = new OtherDesignatedContact();
    this.displayOtherDesignatedContactDialog = true;
  }

  saveNameAndIdentifier() {
    const formGroup = this.formArray.get([2]) as FormGroup;
    this.nameAndIdentifier.systemName = formGroup.controls.systemName.value;
    this.nameAndIdentifier.systemNameAbbreviation =
      formGroup.controls.systemNameAbbreviation.value;
    this.nameAndIdentifier.type = formGroup.controls.type.value;
    this.nameAndIdentifier.description = formGroup.controls.description.value;

    let namesAndIdentifiers = [...this.namesAndIdentifiers];
    if (this.newNameAndIdentifier)
      namesAndIdentifiers.push(this.nameAndIdentifier);
    else
      namesAndIdentifiers[
        this.namesAndIdentifiers.indexOf(this.selectedNameAndIdentifier)
        ] = this.nameAndIdentifier;

    this.namesAndIdentifiers = namesAndIdentifiers;
    this.nameAndIdentifier = null;

    this.displayNameAndIdentifierDialog = false;
  }

  saveSystemLocation() {
    const formGroup = this.formArray.get([3]) as FormGroup;
    this.systemLocation.subSystemName = formGroup.controls.subSystemName.value;
    this.systemLocation.responsibility =
      formGroup.controls.responsibility.value;
    this.systemLocation.location = formGroup.controls.location.value;
    this.systemLocation.systemType = formGroup.controls.systemType.value;

    let systemLocations = [...this.systemLocations];
    if (this.newSystemLocation) systemLocations.push(this.systemLocation);
    else
      systemLocations[
        this.systemLocations.indexOf(this.selectedSystemLocation)
        ] = this.systemLocation;

    this.systemLocations = systemLocations;
    this.systemLocation = null;

    this.displaySystemLocationDialog = false;
  }

  saveDevice() {
    const formGroup = this.formArray.get([3]) as FormGroup;
    this.device.deviceName = formGroup.controls.deviceName.value;
    this.device.type = formGroup.controls.type.value;
    this.device.manufacturer = formGroup.controls.manufacturer.value;
    this.device.model = formGroup.controls.model.value;
    this.device.serialNumber = formGroup.controls.serialNumber.value;
    this.device.ip = formGroup.controls.ip.value;
    this.device.mac = formGroup.controls.mac.value;
    this.device.puid = formGroup.controls.puid.value;
    this.device.owner = formGroup.controls.owner.value;
    this.device.location = formGroup.controls.deviceLocation.value;
    this.device.projectControlItems = this.projectControlItems;

    let devices = [...this.devices];
    if (this.newDevice) devices.push(this.device);
    else devices[this.devices.indexOf(this.selectedDevice)] = this.device;

    this.devices = devices;
    this.device = null;
    this.projectControlItems = [];

    this.displayDeviceDialog = false;
  }

  addProjectControlItem() {
    let config = {
      width: '90%',
      height: '90%',
      data: {
        except: this.projectControlItems || [],
      },
    };

    this.selectDialogRef = this.dialogService.open(
      SelectProjectControlItemComponent,
      config
    );

    this.selectDialogRef.onClose.subscribe((data: any) => {
      if (data) this.projectControlItems = [...this.projectControlItems, data];
      this.cdRef.detectChanges();
    });
  }

  removeProjectControlItem(c) {
    this.projectControlItems = this.projectControlItems.filter((v) => v !== c);
  }

  saveRole() {
    const formGroup = this.formArray.get([5 + 1]) as FormGroup;
    this.role.role = formGroup.controls.roleFormChildCtrl.value;
    this.role.isInternal = formGroup.controls.isInternal.value;
    this.role.access = formGroup.controls.accessFormChildCtrl.value;
    this.role.sensitivityLevel = formGroup.controls.sensitivityLevel.value;
    this.role.authorizedPrivileges =
      formGroup.controls.authorizedPrivileges.value;
    this.role.authorizedFunctionsPerformed =
      formGroup.controls.authorizedFunctionsPerformedFormChildCtrl.value;

    let roles = [...this.roles];
    if (this.newRole) roles.push(this.role);
    else roles[this.roles.indexOf(this.selectedRole)] = this.role;

    this.roles = roles;
    this.role = null;

    //formGroup.controls.roleFormChildCtrl.setValue(null);
    //formGroup.controls.accessFormChildCtrl.setValue(null);
    //formGroup.controls.authorizedFunctionsPerformedFormChildCtrl.setValue(null);

    this.displayRoleDialog = false;
  }

  saveSystemUser() {
    const formGroup = this.formArray.get([33]) as FormGroup;
    this.systemUser.name = formGroup.controls.name.value;
    this.systemUser.role = formGroup.controls.role.value;
    this.systemUser.reviewedDate = formGroup.controls.reviewedDate.value;
    this.systemUser.lastLoginDate = formGroup.controls.lastLoginDate.value;

    let systemUsers = [...this.systemUsers];
    if (this.newSystemUser) systemUsers.push(this.systemUser);
    else systemUsers[this.systemUsers.indexOf(this.selectedSystemUser)] = this.systemUser;

    this.systemUsers = systemUsers;
    this.systemUser = null;

    //formGroup.controls.systemUserFormChildCtrl.setValue(null);
    //formGroup.controls.accessFormChildCtrl.setValue(null);
    //formGroup.controls.authorizedFunctionsPerformedFormChildCtrl.setValue(null);

    this.displaySystemUserDialog = false;
  }

  saveSeparatedUser() {
    const formGroup = this.formArray.get([34]) as FormGroup;
    this.separatedUser.name = formGroup.controls.name.value;
    this.separatedUser.separationDate = formGroup.controls.separationDate.value;
    this.separatedUser.accessRevoked = formGroup.controls.accessRevoked.value;
    this.separatedUser.revokationDate = formGroup.controls.revokationDate.value;

    let separatedUsers = [...this.separatedUsers];
    if (this.newSeparatedUser) separatedUsers.push(this.separatedUser);
    else separatedUsers[this.separatedUsers.indexOf(this.selectedSeparatedUser)] = this.separatedUser;

    this.separatedUsers = separatedUsers;
    this.separatedUser = null;

    this.displaySeparatedUserDialog = false;
  }

  onPrimaryColorChange(color: any) {
    this.primaryColor = color;
  }

  onPrimaryTextColorChange(color: any) {
    this.primaryTextColor = color;
  }

  onSecondaryColorChange(color: any) {
    this.secondaryColor = color;
  }

  onSecondaryTextColorChange(color: any) {
    this.secondaryTextColor = color;
  }

  onTertiaryColorChange(color: any) {
    this.tertiaryColor = color;
  }

  onTertiaryTextColorChange(color: any) {
    this.tertiaryTextColor = color;
  }

  saveInterconnection() {
    const formGroup = this.formArray.get([21]) as FormGroup;
    this.interconnection.addressAndInterface =
      formGroup.controls.addressAndInterface.value;
    this.interconnection.externalOrgName =
      formGroup.controls.externalOrgNameFormChildCtrl.value;
    this.interconnection.externalPointOfContact =
      formGroup.controls.externalPointOfContactFormChildCtrl.value;
    this.interconnection.connectionSecurity =
      formGroup.controls.connectionSecurityFormChildCtrl.value;
    this.interconnection.dataDirection =
      formGroup.controls.dataDirectionFormChildCtrl.value.value;
    this.interconnection.informationBeingTransmitted =
      formGroup.controls.informationBeingTransmittedFormChildCtrl.value;
    this.interconnection.portOrCircuitNumbers =
      formGroup.controls.portOrCircuitNumbersFormChildCtrl.value;

    let interconnections = [...this.interconnections];
    if (this.newInterconnection) interconnections.push(this.interconnection);
    else
      interconnections[
        this.interconnections.indexOf(this.selectedInterconnection)
        ] = this.interconnection;

    this.interconnections = interconnections;
    this.interconnection = null;
    this.displayInterconnectionDialog = false;
  }

  saveOtherDesignatedContact() {
    const formGroup = this.formArray.get([10]) as FormGroup;
    this.otherDesignatedContact.role = formGroup.controls.role.value;
    this.otherDesignatedContact.name = formGroup.controls.name.value;
    this.otherDesignatedContact.title = formGroup.controls.title.value;
    this.otherDesignatedContact.company = formGroup.controls.company.value;
    this.otherDesignatedContact.address = formGroup.controls.address.value;
    this.otherDesignatedContact.phone = formGroup.controls.phone.value;
    this.otherDesignatedContact.email = formGroup.controls.email.value;

    let otherDesignatedContacts = [...this.otherDesignatedContacts];
    if (this.newOtherDesignatedContact)
      otherDesignatedContacts.push(this.otherDesignatedContact);
    else
      otherDesignatedContacts[
        this.otherDesignatedContacts.indexOf(
          this.selectedOtherDesignatedContact
        )
        ] = this.otherDesignatedContact;

    this.otherDesignatedContacts = otherDesignatedContacts;
    this.otherDesignatedContact = null;

    this.displayOtherDesignatedContactDialog = false;
  }

  onNameAndIdentifierDelete(nameAndIdentifier) {
    this.namesAndIdentifiers = this.namesAndIdentifiers.filter(
      (i) => i != nameAndIdentifier
    );
    this.nameAndIdentifier = null;
  }

  onSystemLocationDelete(systemLocation) {
    let index = this.systemLocations.indexOf(systemLocation);
    this.systemLocations = this.systemLocations.filter((val, i) => i != index);
    this.systemLocation = null;
  }

  onDeviceDelete(device) {
    let index = this.devices.indexOf(device);
    this.devices = this.devices.filter((val, i) => i != index);
    this.device = null;
  }

  onRoleDelete(role) {
    let index = this.roles.indexOf(role);
    this.roles = this.roles.filter((val, i) => i != index);
    this.role = null;
  }

  onSystemUserDelete(role) {
    let index = this.systemUsers.indexOf(role);
    this.systemUsers = this.systemUsers.filter((val, i) => i != index);
    this.systemUser = null;
  }

  onSeparatedUserDelete(role) {
    let index = this.separatedUsers.indexOf(role);
    this.separatedUsers = this.separatedUsers.filter((val, i) => i != index);
    this.separatedUser = null;
  }

  onInterconnectionDelete(interconnection) {
    let index = this.interconnections.indexOf(this.interconnection);
    this.interconnections = this.interconnections.filter(
      (val, i) => i != index
    );
    this.interconnection = null;
  }

  onOtherDesignatedContactDelete(otherDesignatedContact) {
    let index = this.otherDesignatedContacts.indexOf(otherDesignatedContact);
    this.otherDesignatedContacts = this.otherDesignatedContacts.filter(
      (val, i) => i != index
    );
    this.otherDesignatedContact = null;
  }

  onNameAndIdentifierEdit(nameAndIdentifier) {
    this.newNameAndIdentifier = false;
    this.selectedNameAndIdentifier = nameAndIdentifier;
    this.nameAndIdentifier = Object.assign({}, nameAndIdentifier);

    const namesAndIdentifiersGroup = this.formArray.get([2]) as FormGroup;
    namesAndIdentifiersGroup.controls.systemName.setValue(
      nameAndIdentifier.systemName
    );
    namesAndIdentifiersGroup.controls.systemNameAbbreviation.setValue(
      nameAndIdentifier.systemNameAbbreviation
    );
    namesAndIdentifiersGroup.controls.type.setValue(nameAndIdentifier.type);
    namesAndIdentifiersGroup.controls.description.setValue(
      nameAndIdentifier.description
    );

    this.displayNameAndIdentifierDialog = true;
  }

  onSystemLocationEdit(systemLocation) {
    this.newSystemLocation = false;
    this.selectedSystemLocation = systemLocation;
    this.systemLocation = Object.assign({}, systemLocation);

    const systemLocationsGroup = this.formArray.get([3]) as FormGroup;
    systemLocationsGroup.controls.subSystemName.setValue(
      systemLocation.subSystemName
    );
    systemLocationsGroup.controls.responsibility.setValue(
      systemLocation.responsibility
    );
    systemLocationsGroup.controls.location.setValue(systemLocation.location);
    systemLocationsGroup.controls.systemType.setValue(
      systemLocation.systemType
    );

    this.displaySystemLocationDialog = true;
  }

  onDeviceEdit(device) {
    this.newDevice = false;
    this.selectedDevice = device;
    this.device = Object.assign({}, device);

    const devicesGroup = this.formArray.get([3]) as FormGroup;
    devicesGroup.controls.deviceName.setValue(device.deviceName);
    devicesGroup.controls.type.setValue(device.type);
    devicesGroup.controls.manufacturer.setValue(device.manufacturer);
    devicesGroup.controls.model.setValue(device.model);
    devicesGroup.controls.serialNumber.setValue(device.serialNumber);
    devicesGroup.controls.ip.setValue(device.ip);
    devicesGroup.controls.mac.setValue(device.mac);
    devicesGroup.controls.puid.setValue(device.puid);
    devicesGroup.controls.owner.setValue(device.owner);
    devicesGroup.controls.deviceLocation.setValue(device.location);
    this.projectControlItems = device.projectControlItems || [];
    this.displayDeviceDialog = true;
  }

  onRoleEdit(role) {
    this.newRole = false;
    this.selectedRole = role;
    this.role = Object.assign({}, role);

    const rolesGroup = this.formArray.get([5 + 1]) as FormGroup;
    rolesGroup.controls.roleFormChildCtrl.setValue(role.role);
    rolesGroup.controls.isInternal.setValue(role.isInternal);
    rolesGroup.controls.accessFormChildCtrl.setValue(role.access);
    rolesGroup.controls.sensitivityLevel.setValue(role.sensitivityLevel);
    rolesGroup.controls.authorizedPrivileges.setValue(
      role.authorizedPrivileges
    );
    rolesGroup.controls.authorizedFunctionsPerformedFormChildCtrl.setValue(
      role.authorizedFunctionsPerformed
    );

    this.displayRoleDialog = true;
  }

  onSystemUserEdit(systemUser) {
    this.newSystemUser = false;
    this.selectedSystemUser = systemUser;
    this.systemUser = Object.assign({}, systemUser);

    const systemUsersGroup = this.formArray.get([33]) as FormGroup;
    systemUsersGroup.controls.name.setValue(systemUser.name);
    systemUsersGroup.controls.role.setValue(systemUser.role);
    systemUsersGroup.controls.reviewedDate.setValue(systemUser.reviewedDate);
    systemUsersGroup.controls.lastLoginDate.setValue(systemUser.lastLoginDate);

    this.displaySystemUserDialog = true;
  }

  onSeparatedUserEdit(systemUser) {
    this.newSeparatedUser = false;
    this.selectedSeparatedUser = systemUser;
    this.systemUser = Object.assign({}, systemUser);

    const systemUsersGroup = this.formArray.get([34]) as FormGroup;
    systemUsersGroup.controls.name.setValue(systemUser.name);
    systemUsersGroup.controls.separationDate.setValue(systemUser.separationDate);
    systemUsersGroup.controls.accessRevoked.setValue(systemUser.accessRevoked);
    systemUsersGroup.controls.revokationDate.setValue(systemUser.revokationDate);

    this.displaySeparatedUserDialog = true;
  }

  onInterconnectionEdit(interconnection) {
    this.newInterconnection = false;
    this.selectedInterconnection = interconnection;
    this.interconnection = Object.assign({}, interconnection);

    const interconnectionsGroup = this.formArray.get([21]) as FormGroup;

    interconnectionsGroup.controls.addressAndInterface.setValue(
      interconnection.addressAndInterface
    );
    interconnectionsGroup.controls.externalOrgNameFormChildCtrl.setValue(
      interconnection.externalOrgName
    );
    interconnectionsGroup.controls.externalPointOfContactFormChildCtrl.setValue(
      interconnection.externalPointOfContact
    );
    interconnectionsGroup.controls.connectionSecurityFormChildCtrl.setValue(
      interconnection.connectionSecurity
    );

    const interconnectionDataDirection = this.dataDirectionList.find(
      (x) => x.value == interconnection.dataDirection
    );

    interconnectionsGroup.controls.dataDirectionFormChildCtrl.setValue(
      interconnectionDataDirection != null
        ? interconnectionDataDirection
        : {
          label: DataDirection[0].toString(),
          value: 0,
        }
    );
    interconnectionsGroup.controls.informationBeingTransmittedFormChildCtrl.setValue(
      interconnection.informationBeingTransmitted
    );
    interconnectionsGroup.controls.portOrCircuitNumbersFormChildCtrl.setValue(
      interconnection.portOrCircuitNumbers
    );

    this.displayInterconnectionDialog = true;
  }

  onOtherDesignatedContactEdit(otherDesignatedContact) {
    this.newOtherDesignatedContact = false;
    this.selectedOtherDesignatedContact = otherDesignatedContact;
    this.otherDesignatedContact = Object.assign({}, otherDesignatedContact);

    const otherDesignatedContactsGroup = this.formArray.get([10]) as FormGroup;
    otherDesignatedContactsGroup.controls.role.setValue(
      otherDesignatedContact.role
    );
    otherDesignatedContactsGroup.controls.name.setValue(
      otherDesignatedContact.name
    );
    otherDesignatedContactsGroup.controls.title.setValue(
      otherDesignatedContact.title
    );
    otherDesignatedContactsGroup.controls.company.setValue(
      otherDesignatedContact.company
    );
    otherDesignatedContactsGroup.controls.address.setValue(
      otherDesignatedContact.address
    );
    otherDesignatedContactsGroup.controls.phone.setValue(
      otherDesignatedContact.phone
    );
    otherDesignatedContactsGroup.controls.email.setValue(
      otherDesignatedContact.email
    );

    this.displayOtherDesignatedContactDialog = true;
  }

  closeNameAndIdentifierDialog() {
    this.displayNameAndIdentifierDialog = false;
  }

  closeSystemLocationDialog() {
    this.displaySystemLocationDialog = false;
  }

  closeDeviceDialog() {
    this.displayDeviceDialog = false;
  }

  closeRoleDialog() {
    this.displayRoleDialog = false;
  }

  closeSystemUserDialog() {
    this.displaySystemUserDialog = false;
  }

  closeSeparatedUserDialog() {
    this.displaySeparatedUserDialog = false;
  }

  closeInterconnectionDialog() {
    this.displayInterconnectionDialog = false;
  }

  closeOtherDesignatedContactDialog() {
    this.displayOtherDesignatedContactDialog = false;
  }

  onDone() {
    const clientITProfile = new ClientITProfile();

    const firstGroup = this.formArray.get([0]) as FormGroup;

    clientITProfile.clientITProfileId = this.itProfile.clientITProfileId;
    clientITProfile.quiz = this.itProfile.quiz;
    clientITProfile.quizData = this.itProfile.quizData;

    clientITProfile.name = this.itProfile.name;

    clientITProfile.systemOwnerClientContact = new ClientContact();
    clientITProfile.systemOwnerClientContact.role =
      ClientContactRole.SystemOwner;
    clientITProfile.ownersSectionVisible =
      firstGroup.controls.ownersSectionVisible.value;
    clientITProfile.ownersSectionTitle =
      firstGroup.controls.ownersSectionTitle.value;
    clientITProfile.systemOwnerClientContact.fullName =
      firstGroup.controls.systemOwnerFullNameFormCtrl.value;
    clientITProfile.systemOwnerClientContact.title =
      firstGroup.controls.systemOwnerTitleFormCtrl.value;
    clientITProfile.systemOwnerClientContact.company =
      firstGroup.controls.systemOwnerCompanyFormCtrl.value;
    clientITProfile.systemOwnerClientContact.address =
      firstGroup.controls.systemOwnerAddressFormCtrl.value;
    clientITProfile.systemOwnerClientContact.phone =
      firstGroup.controls.systemOwnerPhoneFormCtrl.value;
    clientITProfile.systemOwnerClientContact.email =
      firstGroup.controls.systemOwnerEmailFormCtrl.value;
    clientITProfile.systemOwnerClientContact.clientContactId = (
      this.itProfile || {}
    ).systemOwnerClientContactId;

    clientITProfile.securityPointClientContact = new ClientContact();
    clientITProfile.securityPointClientContact.role =
      ClientContactRole.SecurityPoint;
    clientITProfile.securityPointClientContact.fullName =
      firstGroup.controls.securityPointFullNameFormCtrl.value;
    clientITProfile.securityPointClientContact.title =
      firstGroup.controls.securityPointTitleFormCtrl.value;
    clientITProfile.securityPointClientContact.company =
      firstGroup.controls.securityPointCompanyFormCtrl.value;
    clientITProfile.securityPointClientContact.address =
      firstGroup.controls.securityPointAddressFormCtrl.value;
    clientITProfile.securityPointClientContact.phone =
      firstGroup.controls.securityPointPhoneFormCtrl.value;
    clientITProfile.securityPointClientContact.email =
      firstGroup.controls.securityPointEmailFormCtrl.value;
    clientITProfile.securityPointClientContact.clientContactId = (
      this.itProfile || {}
    ).securityPointClientContactId;

    clientITProfile.securityOfficerClientContact = new ClientContact();
    clientITProfile.securityOfficerClientContact.role =
      ClientContactRole.SecurityOfficer;
    clientITProfile.securityOfficerClientContact.fullName =
      firstGroup.controls.securityOfficerFullNameFormCtrl.value;
    clientITProfile.securityOfficerClientContact.title =
      firstGroup.controls.securityOfficerTitleFormCtrl.value;
    clientITProfile.securityOfficerClientContact.company =
      firstGroup.controls.securityOfficerCompanyFormCtrl.value;
    clientITProfile.securityOfficerClientContact.address =
      firstGroup.controls.securityOfficerAddressFormCtrl.value;
    clientITProfile.securityOfficerClientContact.phone =
      firstGroup.controls.securityOfficerPhoneFormCtrl.value;
    clientITProfile.securityOfficerClientContact.email =
      firstGroup.controls.securityOfficerEmailFormCtrl.value;
    clientITProfile.securityOfficerClientContact.clientContactId = (
      this.itProfile || {}
    ).securityOfficerClientContactId;

    let generalPurposeGroup = this.formArray.get([1]) as FormGroup;
    clientITProfile.introSectionVisible =
      generalPurposeGroup.controls.introSectionVisible.value;
    clientITProfile.introSectionTitle =
      generalPurposeGroup.controls.introSectionTitle.value;
    clientITProfile.generalPurpose =
      generalPurposeGroup.controls.generalPurposeFormCtrl.value;
    clientITProfile.fedRampApplicationNumber =
      generalPurposeGroup.controls.fedRampApplicationNumber.value;
    clientITProfile.systemName = generalPurposeGroup.controls.systemName.value;
    clientITProfile.systemNameAbbreviation =
      generalPurposeGroup.controls.systemNameAbbreviation.value;
    clientITProfile.introduction =
      generalPurposeGroup.controls.introduction.value;

    const namesGroup = this.formArray.get([2]) as FormGroup;
    clientITProfile.namesSectionVisible =
      namesGroup.controls.namesSectionVisible.value;
    clientITProfile.namesSectionTitle =
      namesGroup.controls.namesSectionTitle.value;

    const locationGroup = this.formArray.get([3]) as FormGroup;
    clientITProfile.locationSectionVisible =
      locationGroup.controls.locationSectionVisible.value;
    clientITProfile.devicesSectionVisible =
      locationGroup.controls.devicesSectionVisible.value;
    clientITProfile.locationSectionTitle =
      locationGroup.controls.locationSectionTitle.value;

    const typesOfInformationGroup = this.formArray.get([4]) as FormGroup;
    clientITProfile.typesSectionVisible =
      typesOfInformationGroup.controls.typesSectionVisible.value;
    clientITProfile.typesSectionTitle =
      typesOfInformationGroup.controls.typesSectionTitle.value;
    clientITProfile.typesOfInformation =
      typesOfInformationGroup.controls.typesOfInformationFormCtrl.value;

    generalPurposeGroup = this.formArray.get([5]) as FormGroup;
    clientITProfile.boundarySectionVisible =
      generalPurposeGroup.controls.boundarySectionVisible.value;
    clientITProfile.boundarySectionTitle =
      generalPurposeGroup.controls.boundarySectionTitle.value;
    clientITProfile.systemBoundaryPreDescription =
      generalPurposeGroup.controls.systemBoundaryPreDescriptionFormCtrl.value;
    clientITProfile.systemBoundaryDescription =
      generalPurposeGroup.controls.systemBoundaryDescriptionFormCtrl.value;
    clientITProfile.systemBoundaryDiagram = this.systemBoundaryDiagram;
    clientITProfile.dataFlowDescription =
      generalPurposeGroup.controls.dataFlowDescription.value;
    clientITProfile.systemEnvironmentAndInventory =
      generalPurposeGroup.controls.systemEnvironmentAndInventory.value;
    clientITProfile.dataFlowDiagram = this.dataFlowDiagram;

    clientITProfile.nameAndIdentifiers = this.namesAndIdentifiers || [];

    clientITProfile.systemLocations = this.systemLocations || [];
    clientITProfile.devices = this.devices || [];

    clientITProfile.otherDesignatedContacts = this.otherDesignatedContacts || [];
    clientITProfile.sensitivityCategorizations =
      this.sensitivityCategorizations || [];
    clientITProfile.controlOriginations = this.controlOriginations || [];
    clientITProfile.leveragedAuthorizations = this.leveragedAuthorizations || [];
    clientITProfile.portProtocolServices = this.portProtocolServices || [];
    clientITProfile.standartAndGuidances = this.standartAndGuidances || [];
    clientITProfile.informationTypes = this.informationTypes || [];
    clientITProfile.separationOfDuties = this.separationOfDuties || [];
    clientITProfile.separationOfDutyRoles = this.separationOfDutyRoles || [];
    clientITProfile.separationOfDuties.forEach(d => {
      d.separationOfDutyRoles = clientITProfile.separationOfDutyRoles.filter(r => (<any>d).selectedRoles[r.separationOfDutyRoleId]);
    });
    clientITProfile.lawAndRegulations = this.lawAndRegulations || [];
    clientITProfile.systemSecurityPlanApprovals =
      this.systemSecurityPlanApprovals || [];
    clientITProfile.authorizedServices =
      this.authorizedServices || [];
    clientITProfile.externalSystems =
      this.externalSystems || [];

    clientITProfile.systemRolePrivileges = this.roles;
    clientITProfile.systemUsers = this.systemUsers;
    clientITProfile.separatedUsers = this.separatedUsers;

    const rolesGroup = this.formArray.get([19]) as FormGroup;
    clientITProfile.rolesSectionVisible =
      rolesGroup.controls.rolesSectionVisible.value;
    clientITProfile.rolesSectionTitle =
      rolesGroup.controls.rolesSectionTitle.value;
    clientITProfile.internalCount = rolesGroup.controls.internalCount.value;
    clientITProfile.externalCount = rolesGroup.controls.externalCount.value;
    clientITProfile.internalNextYearCount =
      rolesGroup.controls.internalNextYearCount.value;
    clientITProfile.externalNextYearCount =
      rolesGroup.controls.externalNextYearCount.value;

    const systemEnvironmentDescriptionGroup = this.formArray.get([
      6 + 1,
    ]) as FormGroup;
    clientITProfile.environmentSectionVisible =
      systemEnvironmentDescriptionGroup.controls.environmentSectionVisible.value;
    clientITProfile.environmentSectionTitle =
      systemEnvironmentDescriptionGroup.controls.environmentSectionTitle.value;
    clientITProfile.systemEnvironmentDescription =
      systemEnvironmentDescriptionGroup.controls.systemEnvironmentDescriptionFormCtrl.value;
    clientITProfile.serverDescriptions =
      systemEnvironmentDescriptionGroup.controls.serverDescriptionsFormCtrl.value;
    clientITProfile.serverDiagram = this.serverDiagram;
    //console.log(this.serverDiagramFileName);

    const networkDescriptionGroup = this.formArray.get([
      6 + 1 + 1,
    ]) as FormGroup;
    clientITProfile.networkSectionVisible =
      networkDescriptionGroup.controls.networkSectionVisible.value;

    clientITProfile.networkDescriptionsAndDiagrams = [];

    const authorizingOfficialGroup = this.formArray.get([24]) as FormGroup;
    clientITProfile.authorizingOfficial =
      authorizingOfficialGroup.controls.authorizingOfficial.value;

    if (
      networkDescriptionGroup.controls.networkDescriptionFormCtrl1.value !=
      null ||
      this.detailedNetworkDiagram1
    ) {
      const firstNetworkDescriptionAndDiagram =
        new NetworkDescriptionAndDiagram();
      firstNetworkDescriptionAndDiagram.networkDescription =
        networkDescriptionGroup.controls.networkDescriptionFormCtrl1.value;
      firstNetworkDescriptionAndDiagram.networkDiagram =
        this.detailedNetworkDiagram1;
      clientITProfile.networkDescriptionsAndDiagrams.push(
        firstNetworkDescriptionAndDiagram
      );
    }

    if (
      networkDescriptionGroup.controls.networkDescriptionFormCtrl2.value !=
      null ||
      this.detailedNetworkDiagram2
    ) {
      const secondNetworkDescriptionAndDiagram =
        new NetworkDescriptionAndDiagram();
      secondNetworkDescriptionAndDiagram.networkDescription =
        networkDescriptionGroup.controls.networkDescriptionFormCtrl2.value;
      secondNetworkDescriptionAndDiagram.networkDiagram =
        this.detailedNetworkDiagram2;
      clientITProfile.networkDescriptionsAndDiagrams.push(
        secondNetworkDescriptionAndDiagram
      );
    }

    if (
      networkDescriptionGroup.controls.networkDescriptionFormCtrl2.value !=
      null ||
      this.detailedNetworkDiagram2
    ) {
      const thirdNetworkDescriptionAndDiagram =
        new NetworkDescriptionAndDiagram();
      thirdNetworkDescriptionAndDiagram.networkDescription =
        networkDescriptionGroup.controls.networkDescriptionFormCtrl3.value;
      thirdNetworkDescriptionAndDiagram.networkDiagram =
        this.detailedNetworkDiagram3;

      clientITProfile.networkDescriptionsAndDiagrams.push(
        thirdNetworkDescriptionAndDiagram
      );
    }

    clientITProfile.diagrams = this.diagrams;
    clientITProfile.systemInterconnections = this.interconnections;

    const interconnectionGroup = this.formArray.get([9]) as FormGroup;
    clientITProfile.interconnectionSectionVisible =
      interconnectionGroup.controls.interconnectionSectionVisible.value;
    clientITProfile.interconnectionSectionTitle =
      interconnectionGroup.controls.interconnectionSectionTitle.value;

    const contactsGroup = this.formArray.get([16]) as FormGroup;
    clientITProfile.contactsSectionVisible =
      contactsGroup.controls.contactsSectionVisible.value;
    clientITProfile.contactsSectionTitle =
      contactsGroup.controls.contactsSectionTitle.value;

    const sspGroup = this.formArray.get([11]) as FormGroup;
    clientITProfile.date = sspGroup.controls.date.value;
    clientITProfile.description = sspGroup.controls.description.value;
    clientITProfile.versionOfSsp = sspGroup.controls.versionOfSsp.value;
    clientITProfile.sspCompanyName = sspGroup.controls.sspCompanyName.value;
    clientITProfile.isFedRamp = sspGroup.controls.isFedRamp.value;
    clientITProfile.includePolicies = sspGroup.controls.includePolicies.value;
    clientITProfile.includeOwnerNames =
      sspGroup.controls.includeOwnerNames.value;
    clientITProfile.includeResponsibility =
      sspGroup.controls.includeResponsibility.value;
    clientITProfile.includeSubitems =
      sspGroup.controls.includeSubitems.value;
    clientITProfile.primaryColor = this.primaryColor;
    clientITProfile.primaryTextColor = this.primaryTextColor;
    clientITProfile.secondaryColor = this.secondaryColor;
    clientITProfile.secondaryTextColor = this.secondaryTextColor;
    clientITProfile.tertiaryColor = this.tertiaryColor;
    clientITProfile.tertiaryTextColor = this.tertiaryTextColor;
    clientITProfile.author = sspGroup.controls.author.value;

    clientITProfile.profileType =
      this.currentUser.role == Role.Manager ||
      this.currentUser.role == Role.PrimaryManager
        ? CompanyType.Client
        : CompanyType.Advisor;

    const answers = {};
    const quizForm = this.formArray.get([12]) as FormGroup;
    this.quiz.quizData.steps.map((step, stepId) => {
      answers['customVisible' + stepId] =
        quizForm.value['customVisible' + stepId];
      answers['customTitle' + stepId] = quizForm.value['customTitle' + stepId];
      step.items.map((item, itemId) => {
        if (item.type == 'question') {
          answers['r' + stepId + '_' + itemId] = [];
          if (item.multiple) {
            item.answers.map((answer, answerId) => {
              if (
                quizForm.value['r' + stepId + '_' + itemId + '_' + answerId]
              ) {
                answers['r' + stepId + '_' + itemId].push(answerId);
              }
            });
          } else {
            answers['r' + stepId + '_' + itemId] = [
              quizForm.value['r' + stepId + '_' + itemId],
            ];
          }
        }
      });
    });

    const fedRampGroup = this.formArray.get([14]) as FormGroup;
    clientITProfile.systemSensivityLevel =
      fedRampGroup.controls.systemSensivityLevel.value;
    clientITProfile.confidentiality =
      fedRampGroup.controls.confidentiality.value;
    clientITProfile.integrity = fedRampGroup.controls.integrity.value;
    clientITProfile.availability = fedRampGroup.controls.availability.value;
    clientITProfile.abbreviationCategorization =
      fedRampGroup.controls.abbreviationCategorization.value;
    clientITProfile.isSystemStatusOperational =
      fedRampGroup.controls.isSystemStatusOperational.value;
    clientITProfile.isSystemStatusUnderDevelopment =
      fedRampGroup.controls.isSystemStatusUnderDevelopment.value;
    clientITProfile.isSystemStatusMajorModification =
      fedRampGroup.controls.isSystemStatusMajorModification.value;
    clientITProfile.isSystemStatusOther =
      fedRampGroup.controls.isSystemStatusOther.value;
    clientITProfile.systemStatusOtherExplanation =
      fedRampGroup.controls.systemStatusOtherExplanation.value;
    clientITProfile.isSoftwareLayer =
      fedRampGroup.controls.isSoftwareLayer.value;
    clientITProfile.isPlatformLayer =
      fedRampGroup.controls.isPlatformLayer.value;
    clientITProfile.isInfrastructureLayer =
      fedRampGroup.controls.isInfrastructureLayer.value;
    clientITProfile.isOtherLayer = fedRampGroup.controls.isOtherLayer.value;
    clientITProfile.otherLayer = fedRampGroup.controls.otherLayer.value;
    clientITProfile.isPublicCloud = fedRampGroup.controls.isPublicCloud.value;
    clientITProfile.isPrivateCloud = fedRampGroup.controls.isPrivateCloud.value;
    clientITProfile.isGovernmentCloud =
      fedRampGroup.controls.isGovernmentCloud.value;
    clientITProfile.isHybridCloud = fedRampGroup.controls.isHybridCloud.value;
    clientITProfile.hybridCloud = fedRampGroup.controls.hybridCloud.value;
    clientITProfile.identityAssuranceLevel =
      fedRampGroup.controls.identityAssuranceLevel.value;
    clientITProfile.authenticatorAssuranceLevel =
      fedRampGroup.controls.authenticatorAssuranceLevel.value;
    clientITProfile.federationAssuranceLevel =
      fedRampGroup.controls.federationAssuranceLevel.value;
    clientITProfile.isaSharesPii = fedRampGroup.controls.isaSharesPii.value;
    clientITProfile.isaSharesPiiPublic =
      fedRampGroup.controls.isaSharesPiiPublic.value;
    clientITProfile.piaPerformedForIsa =
      fedRampGroup.controls.piaPerformedForIsa.value;
    clientITProfile.isSorn = fedRampGroup.controls.isSorn.value;
    clientITProfile.sorn = fedRampGroup.controls.sorn.value;
    clientITProfile.rulesOfBehaviour = this.rulesOfBehaviour;
    clientITProfile.contingencyPlan = this.rulesOfBehaviour;
    clientITProfile.configurationManagementPlan =
      this.configurationManagementPlan;
    clientITProfile.incidentResponsePlan = this.incidentResponsePlan;
    clientITProfile.seperationOfDutiesMatrix = this.seprationOfDutiesMatrix;
    clientITProfile.relatedAcronyms = this.relatedAcronyms;
    clientITProfile.policiesAndProcedures = this.policiesAndProcedures;
    clientITProfile.userGuide = this.userGuide;
    clientITProfile.controlImplementationSummary = this.controlImplementationSummary;
    clientITProfile.integratedInventoryWorkbook = this.integratedInventoryWorkbook;
    clientITProfile.continuousMonitoringPlan = this.continuousMonitoringPlan;
    clientITProfile.supplyChainRiskManagementPlan = this.supplyChainRiskManagementPlan;
    clientITProfile.cryptographicModulesTable = this.cryptographicModulesTable;

    const additionalInformationGroup = this.formArray.get([18]) as FormGroup;
    clientITProfile.systemFunctionOrPurpose =
      additionalInformationGroup.controls.systemFunctionOrPurpose.value;
    clientITProfile.isFedRampAuthorizationPlanned =
      additionalInformationGroup.controls.isFedRampAuthorizationPlanned.value;

    const appendicesGroup = this.formArray.get([25]) as FormGroup;
    clientITProfile.isUserGuideUrl = appendicesGroup.controls.isUserGuideUrl.value;
    clientITProfile.userGuideUrl = appendicesGroup.controls.userGuideUrl.value;

    const fedRamp5Group = this.formArray.get([26]) as FormGroup;
    clientITProfile.csoName = fedRamp5Group.controls.csoName.value;
    clientITProfile.csoAbbreviation = fedRamp5Group.controls.csoAbbreviation.value;
    clientITProfile.csoCategorization = fedRamp5Group.controls.csoCategorization.value;
    clientITProfile.cspName = fedRamp5Group.controls.cspName.value;
    clientITProfile.cspAbbreviation = fedRamp5Group.controls.cspAbbreviation.value;
    clientITProfile.fedRampPackageId = fedRamp5Group.controls.fedRampPackageId.value;
    clientITProfile.serviceModel = fedRamp5Group.controls.serviceModel.value;
    clientITProfile.digitalIdentityLevel = fedRamp5Group.controls.digitalIdentityLevel.value;
    clientITProfile.fipsLevel = fedRamp5Group.controls.fipsLevel.value;
    clientITProfile.operationalDate = fedRamp5Group.controls.operationalDate.value;
    clientITProfile.deploymentModel = fedRamp5Group.controls.deploymentModel.value;
    clientITProfile.authorizationPath = fedRamp5Group.controls.authorizationPath.value;
    clientITProfile.separationOfDutiesVisible = fedRamp5Group.controls.separationOfDutiesVisible.value;
    clientITProfile.digitalIdentityLevel1 = fedRamp5Group.controls.digitalIdentityLevel1.value;
    clientITProfile.digitalIdentityLevel2 = fedRamp5Group.controls.digitalIdentityLevel2.value;
    clientITProfile.digitalIdentityLevel3 = fedRamp5Group.controls.digitalIdentityLevel3.value;

    const itStackGroup = this.formArray.get([32]) as FormGroup;
    clientITProfile.deploymentType = itStackGroup.controls.deploymentType.value;
    clientITProfile.primaryOS = itStackGroup.controls.primaryOS.value;
    clientITProfile.identityManagement = itStackGroup.controls.identityManagement.value;
    clientITProfile.firewallProduct = itStackGroup.controls.firewallProduct.value;
    clientITProfile.configManagementProduct = itStackGroup.controls.configManagementProduct.value;
    clientITProfile.devLanguage = itStackGroup.controls.devLanguage.value;
    clientITProfile.securityTools = itStackGroup.controls.securityTools.value;
    clientITProfile.otherTech1 = itStackGroup.controls.otherTech1.value;
    clientITProfile.operatingSystemStatus = itStackGroup.controls.operatingSystemStatus.value;
    clientITProfile.databaseStatus = itStackGroup.controls.databaseStatus.value;
    clientITProfile.fileStorageStatus = itStackGroup.controls.fileStorageStatus.value;
    clientITProfile.containerScanningStatus = itStackGroup.controls.containerScanningStatus.value;
    clientITProfile.architectureStatus = itStackGroup.controls.architectureStatus.value;
    clientITProfile.devLanguageStatus = itStackGroup.controls.devLanguageStatus.value;
    clientITProfile.configurationManagementStatus = itStackGroup.controls.configurationManagementStatus.value;
    clientITProfile.accessManagementStatus = itStackGroup.controls.accessManagementStatus.value;
    clientITProfile.keyManagementStatus = itStackGroup.controls.keyManagementStatus.value;
    clientITProfile.firewallStatus = itStackGroup.controls.firewallStatus.value;
    clientITProfile.codeRepositoryStatus = itStackGroup.controls.codeRepositoryStatus.value;
    clientITProfile.immutabilityStatus = itStackGroup.controls.immutabilityStatus.value;
    clientITProfile.monitoringStatus = itStackGroup.controls.monitoringStatus.value;
    clientITProfile.codeScanningStatus = itStackGroup.controls.codeScanningStatus.value;
    clientITProfile.applicationScanningStatus = itStackGroup.controls.applicationScanningStatus.value;
    clientITProfile.desktopSecurityStatus = itStackGroup.controls.desktopSecurityStatus.value;
    clientITProfile.userAuthStatus = itStackGroup.controls.userAuthStatus.value;
    clientITProfile.loginSecurityStatus = itStackGroup.controls.loginSecurityStatus.value;
    clientITProfile.operatingSystemValue = itStackGroup.controls.operatingSystemValue.value;
    clientITProfile.databaseValue = itStackGroup.controls.databaseValue.value;
    clientITProfile.fileStorageValue = itStackGroup.controls.fileStorageValue.value;
    clientITProfile.containerScanningValue = itStackGroup.controls.containerScanningValue.value;
    clientITProfile.architectureValue = itStackGroup.controls.architectureValue.value;
    clientITProfile.devLanguageValue = itStackGroup.controls.devLanguageValue.value;
    clientITProfile.configurationManagementValue = itStackGroup.controls.configurationManagementValue.value;
    clientITProfile.accessManagementValue = itStackGroup.controls.accessManagementValue.value;
    clientITProfile.keyManagementValue = itStackGroup.controls.keyManagementValue.value;
    clientITProfile.firewallValue = itStackGroup.controls.firewallValue.value;
    clientITProfile.codeRepositoryValue = itStackGroup.controls.codeRepositoryValue.value;
    clientITProfile.immutabilityValue = itStackGroup.controls.immutabilityValue.value;
    clientITProfile.monitoringValue = itStackGroup.controls.monitoringValue.value;
    clientITProfile.codeScanningValue = itStackGroup.controls.codeScanningValue.value;
    clientITProfile.applicationScanningValue = itStackGroup.controls.applicationScanningValue.value;
    clientITProfile.desktopSecurityValue = itStackGroup.controls.desktopSecurityValue.value;
    clientITProfile.userAuthValue = itStackGroup.controls.userAuthValue.value;
    clientITProfile.loginSecurityValue = itStackGroup.controls.loginSecurityValue.value;
    clientITProfile.updateProjects = itStackGroup.controls.updateProjects.value;
    clientITProfile.updateProjectsIds = itStackGroup.controls.updateProjectsIds.value;

    console.log(JSON.stringify(itStackGroup.value));
    clientITProfile.answers = JSON.stringify(answers);

    clientITProfile.boundaryTechnologies = itStackGroup.value.boundaryTechnologies;

    this.alertService.clear();

    this.clientProfileService.updateClientProfile(clientITProfile).subscribe(
      () => {
        this.alertService.success('Profile Successfully Saved');
      },
      (error) => {
        const errorMessage =
          'An error occurred while updating client IT profile.';
        this.alertService.error(errorMessage);
      }
    );
  }

  cloneItProfile() {
    const newProfile = JSON.parse(JSON.stringify(this.itProfile));
    newProfile.name = 'Copy of ' + newProfile.name;
    this.itProfiles.push(newProfile);
    this.selectItProfile(newProfile);
  }

  removeItProfile() {
    this.clientProfileService
      .removeClientProfiles(this.itProfile.clientITProfileId)
      .subscribe(() => this.loadProfiles());
  }

  public addServerDiagramFile(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      this.clientProfileService
        .uploadDiagram(attachments[0])
        .subscribe((data) => {
          this.serverDiagram = attachments[0].name;
        });
    }
  }

  public addSystemBoundaryDiagramFile(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      this.clientProfileService
        .uploadDiagram(attachments[0])
        .subscribe((data) => {
          this.systemBoundaryDiagram = attachments[0].name;
        });
    }
  }

  public addDataFlowDiagramFile(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      this.clientProfileService
        .uploadDiagram(attachments[0])
        .subscribe((data) => {
          this.dataFlowDiagram = attachments[0].name;
        });
    }
  }

  public downloadFile(fileName: string) {
    this.fileBlobService.downloadFile(fileName, 'Account/IT Profile').subscribe(
      (blob) => {
        importedSaveAs(new Blob([blob]), fileName);
      },
      (error) => {
        const errorMessage = 'An error occurred while downloading file.';
        this.alertService.error(errorMessage);
      }
    );
  }

  public downloadServerDiagramFile() {
    this.downloadFile(this.serverDiagram);
  }

  public downloadSystemBoundaryDiagramFile() {
    this.downloadFile(this.systemBoundaryDiagram);
  }

  public downloadDataFlowDiagramFile() {
    this.downloadFile(this.dataFlowDiagram);
  }

  public addDetailedNetworkDiagramFile(event, number) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      this.clientProfileService
        .uploadDiagram(attachments[0])
        .subscribe((data) => {
          switch (number) {
            case 1:
              this.detailedNetworkDiagram1 = attachments[0].name;
              break;

            case 2:
              this.detailedNetworkDiagram2 = attachments[0].name;
              break;

            case 3:
              this.detailedNetworkDiagram3 = attachments[0].name;
              break;
          }
        });
    }
  }

  public downloadDetailedNetworkDiagramFile(number) {
    switch (number) {
      case 1:
        this.downloadFile(this.detailedNetworkDiagram1);
        break;

      case 2:
        this.downloadFile(this.detailedNetworkDiagram2);
        break;

      case 3:
        this.downloadFile(this.detailedNetworkDiagram3);
        break;
    }
  }

  public addDiagramFile(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      this.clientProfileService
        .uploadDiagram(attachments[0])
        .subscribe((data) => {
          const newDiagram = {
            name: data.fileName,
            internalName: data.fileName
          }
          this.handleDiagram(newDiagram);
          this.diagrams = [...this.diagrams, newDiagram];
          this.cdRef.detectChanges();
        });
    }
  }

  public downloadDiagram3dFile(diagram) {
    this.downloadFile(diagram.internalName);
  }

  deleteDiagram(diagram) {
    this.diagrams = this.diagrams.filter(d => d !== diagram);
    this.cdRef.detectChanges();
  }

  populateServices() {
    const projectId = (this.formArray.get([3]) as FormGroup).controls[
      'servicesProjectId'
      ].value;
    if (!projectId) {
      return;
    }
    this.projectsService
      .getServicesForProject(projectId)
      .subscribe((services) => {
        services.forEach((s) => {
          if (this.systemLocations.find((l) => l.subSystemName == s.service)) {
            return;
          }
          this.systemLocations.push({
            subSystemName: s.service,
            responsibility: s.responsibility,
            systemType: '',
            location: '',
          });
        });
      });
  }

  populateDevices(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      this.clientProfileService
        .populateDevices(attachments[0])
        .subscribe((data) => {
          this.devices = [...this.devices, ...data.items];
        });
    }
  }

  showDialogToAddSystemSecurityPlanApproval() {
    const formGroup = this.formArray.get([13]) as FormGroup;
    formGroup.reset({
      name: '',
      date: '',
      title: '',
      providerName: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newSystemSecurityPlanApproval = true;
    this.systemSecurityPlanApproval = new SystemSecurityPlanApproval();
    this.displaySystemSecurityPlanApprovalDialog = true;
  }

  editSystemSecurityPlanApproval(item: SystemSecurityPlanApproval) {
    this.newSystemSecurityPlanApproval = false;
    this.selectedSystemSecurityPlanApproval = item;
    this.systemSecurityPlanApproval = Object.assign({}, item);

    const systemSecurityPlanApprovalGroup = this.formArray.get([
      13,
    ]) as FormGroup;
    systemSecurityPlanApprovalGroup.controls.name.setValue(item.name);
    systemSecurityPlanApprovalGroup.controls.date.setValue(item.date);
    systemSecurityPlanApprovalGroup.controls.title.setValue(item.title);
    systemSecurityPlanApprovalGroup.controls.providerName.setValue(
      item.providerName
    );

    this.displaySystemSecurityPlanApprovalDialog = true;
  }

  deleteSystemSecurityPlanApproval(item) {
    let index = this.systemSecurityPlanApprovals.indexOf(item);
    this.systemSecurityPlanApprovals = this.systemSecurityPlanApprovals.filter(
      (val, i) => i != index
    );
    this.systemSecurityPlanApproval = null;
  }

  saveSystemSecurityPlanApproval() {
    const formGroup = this.formArray.get([13]) as FormGroup;
    if (formGroup.valid) {
      this.systemSecurityPlanApproval.name = formGroup.controls.name.value;
      this.systemSecurityPlanApproval.date = formGroup.controls.date.value;
      this.systemSecurityPlanApproval.title = formGroup.controls.title.value;
      this.systemSecurityPlanApproval.providerName =
        formGroup.controls.providerName.value;

      let systemSecurityPlanApprovals = [...this.systemSecurityPlanApprovals];
      if (this.newSystemSecurityPlanApproval)
        systemSecurityPlanApprovals.push(this.systemSecurityPlanApproval);
      else
        systemSecurityPlanApprovals[
          this.systemSecurityPlanApprovals.indexOf(
            this.selectedSystemSecurityPlanApproval
          )
          ] = this.systemSecurityPlanApproval;

      this.systemSecurityPlanApprovals = systemSecurityPlanApprovals;
      this.systemSecurityPlanApproval = null;

      this.displaySystemSecurityPlanApprovalDialog = false;
    }
  }

  closeSystemSecurityPlanApprovalDialog() {
    this.displaySystemSecurityPlanApprovalDialog = false;
  }

  showDialogToAddSensitivityCategorization() {
    const formGroup = this.formArray.get([15]) as FormGroup;
    formGroup.reset({
      name: '',
      date: '',
      title: '',
      providerName: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newSensitivityCategorization = true;
    this.sensitivityCategorization = new SensitivityCategorization();
    this.displaySensitivityCategorizationDialog = true;
  }

  editSensitivityCategorization(item: SensitivityCategorization) {
    this.newSensitivityCategorization = false;
    this.selectedSensitivityCategorization = item;
    this.sensitivityCategorization = Object.assign({}, item);

    const sensitivityCategorizationGroup = this.formArray.get([
      15,
    ]) as FormGroup;
    sensitivityCategorizationGroup.controls.informationType.setValue(
      item.informationType
    );
    sensitivityCategorizationGroup.controls.identifier.setValue(
      item.identifier
    );
    sensitivityCategorizationGroup.controls.confidentiality.setValue(
      item.confidentiality
    );
    sensitivityCategorizationGroup.controls.integrity.setValue(item.integrity);
    sensitivityCategorizationGroup.controls.availability.setValue(
      item.availability
    );

    this.displaySensitivityCategorizationDialog = true;
  }

  deleteSensitivityCategorization(item) {
    let index = this.sensitivityCategorizations.indexOf(item);
    this.sensitivityCategorizations = this.sensitivityCategorizations.filter(
      (val, i) => i != index
    );
    this.sensitivityCategorization = null;
  }

  saveSensitivityCategorization() {
    const formGroup = this.formArray.get([15]) as FormGroup;
    if (formGroup.valid) {
      this.sensitivityCategorization.informationType =
        formGroup.controls.informationType.value;
      this.sensitivityCategorization.identifier =
        formGroup.controls.identifier.value;
      this.sensitivityCategorization.confidentiality =
        formGroup.controls.confidentiality.value;
      this.sensitivityCategorization.integrity =
        formGroup.controls.integrity.value;
      this.sensitivityCategorization.availability =
        formGroup.controls.availability.value;

      let sensitivityCategorizations = [...this.sensitivityCategorizations];
      if (this.newSensitivityCategorization)
        sensitivityCategorizations.push(this.sensitivityCategorization);
      else
        sensitivityCategorizations[
          this.sensitivityCategorizations.indexOf(
            this.selectedSensitivityCategorization
          )
          ] = this.sensitivityCategorization;

      this.sensitivityCategorizations = sensitivityCategorizations;
      this.sensitivityCategorization = null;

      this.displaySensitivityCategorizationDialog = false;
    }
  }

  closeSensitivityCategorizationDialog() {
    this.displaySensitivityCategorizationDialog = false;
  }

  showDialogToAddLeveragedAuthorization() {
    const formGroup = this.formArray.get([17]) as FormGroup;
    formGroup.reset({
      name: '',
      date: '',
      title: '',
      providerName: '',
      fedramp_identifier: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newLeveragedAuthorization = true;
    this.leveragedAuthorization = new LeveragedAuthorization();
    this.displayLeveragedAuthorizationDialog = true;
  }

  editLeveragedAuthorization(item: LeveragedAuthorization) {
    this.newLeveragedAuthorization = false;
    this.selectedLeveragedAuthorization = item;
    this.leveragedAuthorization = Object.assign({}, item);

    const leveragedAuthorizationGroup = this.formArray.get([17]) as FormGroup;
    leveragedAuthorizationGroup.controls.name.setValue(item.name);
    leveragedAuthorizationGroup.controls.owner.setValue(item.owner);
    leveragedAuthorizationGroup.controls.date.setValue(item.date);
    leveragedAuthorizationGroup.controls.fedramp_identifier.setValue(item.fedramp_identifier);

    this.displayLeveragedAuthorizationDialog = true;
  }

  deleteLeveragedAuthorization(item) {
    let index = this.leveragedAuthorizations.indexOf(item);
    this.leveragedAuthorizations = this.leveragedAuthorizations.filter(
      (val, i) => i != index
    );
    this.leveragedAuthorization = null;
  }

  saveLeveragedAuthorization() {
    const formGroup = this.formArray.get([17]) as FormGroup;
    if (formGroup.valid) {
      this.leveragedAuthorization.name = formGroup.controls.name.value;
      this.leveragedAuthorization.owner = formGroup.controls.owner.value;
      this.leveragedAuthorization.date = formGroup.controls.date.value;
      this.leveragedAuthorization.fedramp_identifier = formGroup.controls.fedramp_identifier.value;

      let leveragedAuthorizations = [...this.leveragedAuthorizations];
      if (this.newLeveragedAuthorization)
        leveragedAuthorizations.push(this.leveragedAuthorization);
      else
        leveragedAuthorizations[
          this.leveragedAuthorizations.indexOf(
            this.selectedLeveragedAuthorization
          )
          ] = this.leveragedAuthorization;

      this.leveragedAuthorizations = leveragedAuthorizations;
      this.leveragedAuthorization = null;

      this.displayLeveragedAuthorizationDialog = false;
    }
  }

  closeLeveragedAuthorizationDialog() {
    this.displayLeveragedAuthorizationDialog = false;
  }

  showDialogToAddPortProtocolService() {
    const formGroup = this.formArray.get([20]) as FormGroup;
    formGroup.reset({
      ports: '',
      protocols: '',
      service: '',
      purpose: '',
      reference: '',
      usedBy: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newPortProtocolService = true;
    this.portProtocolService = new PortProtocolService();
    this.displayPortProtocolServiceDialog = true;
  }

  editPortProtocolService(item: PortProtocolService) {
    this.newPortProtocolService = false;
    this.selectedPortProtocolService = item;
    this.portProtocolService = Object.assign({}, item);

    const portProtocolServiceGroup = this.formArray.get([20]) as FormGroup;
    portProtocolServiceGroup.controls.ports.setValue(item.ports);
    portProtocolServiceGroup.controls.protocols.setValue(item.protocols);
    portProtocolServiceGroup.controls.service.setValue(item.service);
    portProtocolServiceGroup.controls.purpose.setValue(item.purpose);
    portProtocolServiceGroup.controls.reference.setValue(item.reference);
    portProtocolServiceGroup.controls.usedBy.setValue(item.usedBy);

    this.displayPortProtocolServiceDialog = true;
  }

  deletePortProtocolService(item) {
    let index = this.portProtocolServices.indexOf(item);
    this.portProtocolServices = this.portProtocolServices.filter(
      (val, i) => i != index
    );
    this.portProtocolService = null;
  }

  savePortProtocolService() {
    const formGroup = this.formArray.get([20]) as FormGroup;
    if (formGroup.valid) {
      this.portProtocolService.ports = formGroup.controls.ports.value;
      this.portProtocolService.protocols = formGroup.controls.protocols.value;
      this.portProtocolService.service = formGroup.controls.service.value;
      this.portProtocolService.purpose = formGroup.controls.purpose.value;
      this.portProtocolService.reference = formGroup.controls.reference.value;
      this.portProtocolService.usedBy = formGroup.controls.usedBy.value;

      let portProtocolServices = [...this.portProtocolServices];
      if (this.newPortProtocolService)
        portProtocolServices.push(this.portProtocolService);
      else
        portProtocolServices[
          this.portProtocolServices.indexOf(this.selectedPortProtocolService)
          ] = this.portProtocolService;

      this.portProtocolServices = portProtocolServices;
      this.portProtocolService = null;

      this.displayPortProtocolServiceDialog = false;
    }
  }

  closePortProtocolServiceDialog() {
    this.displayPortProtocolServiceDialog = false;
  }

  showDialogToAddLawAndRegulation() {
    const formGroup = this.formArray.get([22]) as FormGroup;
    formGroup.reset({
      identificationNumber: '',
      title: '',
      date: '',
      link: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newLawAndRegulation = true;
    this.lawAndRegulation = new LawAndRegulation();
    this.displayLawAndRegulationDialog = true;
  }

  editLawAndRegulation(item: LawAndRegulation) {
    this.newLawAndRegulation = false;
    this.selectedLawAndRegulation = item;
    this.lawAndRegulation = Object.assign({}, item);

    const lawAndRegulationGroup = this.formArray.get([22]) as FormGroup;
    lawAndRegulationGroup.controls.identificationNumber.setValue(
      item.identificationNumber
    );
    lawAndRegulationGroup.controls.title.setValue(item.title);
    lawAndRegulationGroup.controls.date.setValue(item.date);
    lawAndRegulationGroup.controls.link.setValue(item.link);

    this.displayLawAndRegulationDialog = true;
  }

  deleteLawAndRegulation(item) {
    let index = this.lawAndRegulations.indexOf(item);
    this.lawAndRegulations = this.lawAndRegulations.filter(
      (val, i) => i != index
    );
    this.lawAndRegulation = null;
  }

  saveLawAndRegulation() {
    const formGroup = this.formArray.get([22]) as FormGroup;
    if (formGroup.valid) {
      this.lawAndRegulation.identificationNumber =
        formGroup.controls.identificationNumber.value;
      this.lawAndRegulation.title = formGroup.controls.title.value;
      this.lawAndRegulation.date = formGroup.controls.date.value;
      this.lawAndRegulation.link = formGroup.controls.link.value;

      let lawAndRegulations = [...this.lawAndRegulations];
      if (this.newLawAndRegulation)
        lawAndRegulations.push(this.lawAndRegulation);
      else
        lawAndRegulations[
          this.lawAndRegulations.indexOf(this.selectedLawAndRegulation)
          ] = this.lawAndRegulation;

      this.lawAndRegulations = lawAndRegulations;
      this.lawAndRegulation = null;

      this.displayLawAndRegulationDialog = false;
    }
  }

  closeLawAndRegulationDialog() {
    this.displayLawAndRegulationDialog = false;
  }

  showDialogToAddStandartAndGuidance() {
    const formGroup = this.formArray.get([23]) as FormGroup;
    formGroup.reset({
      identificationNumber: '',
      title: '',
      date: '',
      link: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newStandartAndGuidance = true;
    this.standartAndGuidance = new StandartAndGuidance();
    this.displayStandartAndGuidanceDialog = true;
  }

  editStandartAndGuidance(item: StandartAndGuidance) {
    this.newStandartAndGuidance = false;
    this.selectedStandartAndGuidance = item;
    this.standartAndGuidance = Object.assign({}, item);

    const standartAndGuidanceGroup = this.formArray.get([23]) as FormGroup;
    standartAndGuidanceGroup.controls.identificationNumber.setValue(
      item.identificationNumber
    );
    standartAndGuidanceGroup.controls.title.setValue(item.title);
    standartAndGuidanceGroup.controls.date.setValue(item.date);
    standartAndGuidanceGroup.controls.link.setValue(item.link);

    this.displayStandartAndGuidanceDialog = true;
  }

  deleteStandartAndGuidance(item) {
    let index = this.standartAndGuidances.indexOf(item);
    this.standartAndGuidances = this.standartAndGuidances.filter(
      (val, i) => i != index
    );
    this.standartAndGuidance = null;
  }

  saveStandartAndGuidance() {
    const formGroup = this.formArray.get([23]) as FormGroup;
    if (formGroup.valid) {
      this.standartAndGuidance.identificationNumber =
        formGroup.controls.identificationNumber.value;
      this.standartAndGuidance.title = formGroup.controls.title.value;
      this.standartAndGuidance.date = formGroup.controls.date.value;
      this.standartAndGuidance.link = formGroup.controls.link.value;

      let standartAndGuidances = [...this.standartAndGuidances];
      if (this.newStandartAndGuidance)
        standartAndGuidances.push(this.standartAndGuidance);
      else
        standartAndGuidances[
          this.standartAndGuidances.indexOf(this.selectedStandartAndGuidance)
          ] = this.standartAndGuidance;

      this.standartAndGuidances = standartAndGuidances;
      this.standartAndGuidance = null;

      this.displayStandartAndGuidanceDialog = false;
    }
  }

  closeStandartAndGuidanceDialog() {
    this.displayStandartAndGuidanceDialog = false;
  }

  showDialogToAddInformationType() {
    const formGroup = this.formArray.get([27]) as FormGroup;
    formGroup.reset({
      name: '',
      recommendedConfidentialityLevel: 0,
      recommendedIntegrityLevel: 0,
      recommendedAvailabilityLevel: 0,
      selectedConfidentialityLevel: 0,
      selectedIntegrityLevel: 0,
      selectedAvailabilityLevel: 0,
      statement: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach(key => {
      formGroup.controls[key].setErrors(null);
    });
    this.newInformationType = true;
    this.informationType = new InformationType();
    this.displayInformationTypeDialog = true;
  }

  editInformationType(item: InformationType) {
    this.newInformationType = false;
    this.selectedInformationType = item;
    this.informationType = Object.assign({}, item);

    const informationTypeGroup = this.formArray.get([27]) as FormGroup;
    informationTypeGroup.controls.name.setValue(item.name);
    informationTypeGroup.controls.recommendedConfidentialityLevel.setValue(item.recommendedConfidentialityLevel);
    informationTypeGroup.controls.recommendedIntegrityLevel.setValue(item.recommendedIntegrityLevel);
    informationTypeGroup.controls.recommendedAvailabilityLevel.setValue(item.recommendedAvailabilityLevel);
    informationTypeGroup.controls.selectedConfidentialityLevel.setValue(item.selectedConfidentialityLevel);
    informationTypeGroup.controls.selectedIntegrityLevel.setValue(item.selectedIntegrityLevel);
    informationTypeGroup.controls.selectedAvailabilityLevel.setValue(item.selectedAvailabilityLevel);
    informationTypeGroup.controls.statement.setValue(item.statement);

    this.displayInformationTypeDialog = true;
  }

  deleteInformationType(item) {
    let index = this.informationTypes.indexOf(item);
    this.informationTypes = this.informationTypes.filter((val, i) => i != index);
    this.informationType = null;
  }

  saveInformationType() {
    const formGroup = this.formArray.get([27]) as FormGroup;
    if (formGroup.valid) {
      this.informationType.name = formGroup.controls.name.value;
      this.informationType.recommendedConfidentialityLevel = formGroup.controls.recommendedConfidentialityLevel.value;
      this.informationType.recommendedIntegrityLevel = formGroup.controls.recommendedIntegrityLevel.value;
      this.informationType.recommendedAvailabilityLevel = formGroup.controls.recommendedAvailabilityLevel.value;
      this.informationType.selectedConfidentialityLevel = formGroup.controls.selectedConfidentialityLevel.value;
      this.informationType.selectedIntegrityLevel = formGroup.controls.selectedIntegrityLevel.value;
      this.informationType.selectedAvailabilityLevel = formGroup.controls.selectedAvailabilityLevel.value;
      this.informationType.statement = formGroup.controls.statement.value;

      let informationTypes = [...this.informationTypes];
      if (this.newInformationType)
        informationTypes.push(this.informationType);
      else
        informationTypes[this.informationTypes.indexOf(this.selectedInformationType)] = this.informationType;

      this.informationTypes = informationTypes;
      this.informationType = null;

      this.displayInformationTypeDialog = false;
    }
  }

  closeInformationTypeDialog() {
    this.displayInformationTypeDialog = false;
  }

  showDialogToAddSeparationOfDuty() {
    const formGroup = this.formArray.get([28]) as FormGroup;
    formGroup.reset({
      name: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach(key => {
      formGroup.controls[key].setErrors(null);
    });
    this.newSeparationOfDuty = true;
    this.separationOfDuty = new SeparationOfDuty();
    this.displaySeparationOfDutyDialog = true;
  }

  editSeparationOfDuty(item: SeparationOfDuty) {
    this.newSeparationOfDuty = false;
    this.selectedSeparationOfDuty = item;
    this.separationOfDuty = Object.assign({}, item);

    const separationOfDutyGroup = this.formArray.get([28]) as FormGroup;
    separationOfDutyGroup.controls.name.setValue(item.name);

    this.displaySeparationOfDutyDialog = true;
  }

  deleteSeparationOfDuty(item) {
    let index = this.separationOfDuties.indexOf(item);
    this.separationOfDuties = this.separationOfDuties.filter((val, i) => i != index);
    this.separationOfDuty = null;
  }

  saveSeparationOfDuty() {
    const formGroup = this.formArray.get([28]) as FormGroup;
    if (formGroup.valid) {
      this.separationOfDuty.name = formGroup.controls.name.value;
      (<any>this.separationOfDuty).selectedRoles = (<any>this.separationOfDuty).selectedRoles || {};

      let separationOfDuties = [...this.separationOfDuties];
      if (this.newSeparationOfDuty)
        separationOfDuties.push(this.separationOfDuty);
      else
        separationOfDuties[this.separationOfDuties.indexOf(this.selectedSeparationOfDuty)] = this.separationOfDuty;

      this.separationOfDuties = separationOfDuties;
      this.separationOfDuty = null;

      this.displaySeparationOfDutyDialog = false;
    }
  }

  closeSeparationOfDutyDialog() {
    this.displaySeparationOfDutyDialog = false;
  }

  showDialogToAddSeparationOfDutyRole() {
    const formGroup = this.formArray.get([29]) as FormGroup;
    formGroup.reset({
      name: ''
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach(key => {
      formGroup.controls[key].setErrors(null);
    });
    this.newSeparationOfDutyRole = true;
    this.separationOfDutyRole = new SeparationOfDutyRole();
    this.separationOfDutyRole.separationOfDutyRoleId = Math.min.apply(null, this.separationOfDutyRoles.map(r => r.separationOfDutyRoleId));
    this.separationOfDutyRole.separationOfDutyRoleId = this.separationOfDutyRole.separationOfDutyRoleId > 0 ? 0 : this.separationOfDutyRole.separationOfDutyRoleId - 1;
    this.displaySeparationOfDutyRoleDialog = true;
  }

  editSeparationOfDutyRole(item: SeparationOfDutyRole) {
    this.newSeparationOfDutyRole = false;
    this.selectedSeparationOfDutyRole = item;
    this.separationOfDutyRole = Object.assign({}, item);

    const separationOfDutyRoleGroup = this.formArray.get([29]) as FormGroup;
    separationOfDutyRoleGroup.controls.name.setValue(item.name);

    this.displaySeparationOfDutyRoleDialog = true;
  }

  deleteSeparationOfDutyRole(item) {
    let index = this.separationOfDutyRoles.indexOf(item);
    this.separationOfDutyRoles = this.separationOfDutyRoles.filter((val, i) => i != index);
    this.separationOfDutyRole = null;
  }

  saveSeparationOfDutyRole() {
    const formGroup = this.formArray.get([29]) as FormGroup;
    if (formGroup.valid) {
      this.separationOfDutyRole.name = formGroup.controls.name.value;

      let separationOfDutyRoles = [...this.separationOfDutyRoles];
      if (this.newSeparationOfDutyRole)
        separationOfDutyRoles.push(this.separationOfDutyRole);
      else
        separationOfDutyRoles[this.separationOfDutyRoles.indexOf(this.selectedSeparationOfDutyRole)] = this.separationOfDutyRole;

      this.separationOfDutyRoles = separationOfDutyRoles;
      this.separationOfDutyRole = null;

      this.displaySeparationOfDutyRoleDialog = false;
    }
  }

  closeSeparationOfDutyRoleDialog() {
    this.displaySeparationOfDutyRoleDialog = false;
  }

  showDialogToAddAuthorizedService() {
    const formGroup = this.formArray.get([30]) as FormGroup;
    formGroup.reset({
      name: '',
      service: '',
      authorizationType: '',
      fedRampPackageId: '',
      nature: '',
      impactLevel: '',
      dataTypes: '',
      users: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newAuthorizedService = true;
    this.authorizedService = new AuthorizedService();
    this.displayAuthorizedServiceDialog = true;
  }

  editAuthorizedService(item: AuthorizedService) {
    this.newAuthorizedService = false;
    this.selectedAuthorizedService = item;
    this.authorizedService = Object.assign({}, item);

    const authorizedServiceGroup = this.formArray.get([
      30,
    ]) as FormGroup;
    authorizedServiceGroup.controls.name.setValue(item.name);
    authorizedServiceGroup.controls.service.setValue(item.service);
    authorizedServiceGroup.controls.authorizationType.setValue(item.authorizationType);
    authorizedServiceGroup.controls.fedRampPackageId.setValue(item.fedRampPackageId);
    authorizedServiceGroup.controls.nature.setValue(item.nature);
    authorizedServiceGroup.controls.impactLevel.setValue(item.impactLevel);
    authorizedServiceGroup.controls.dataTypes.setValue(item.dataTypes);
    authorizedServiceGroup.controls.users.setValue(item.users);

    this.displayAuthorizedServiceDialog = true;
  }

  deleteAuthorizedService(item) {
    let index = this.authorizedServices.indexOf(item);
    this.authorizedServices = this.authorizedServices.filter(
      (val, i) => i != index
    );
    this.authorizedService = null;
  }

  saveAuthorizedService() {
    const formGroup = this.formArray.get([30]) as FormGroup;
    if (formGroup.valid) {
      this.authorizedService.name = formGroup.controls.name.value;
      this.authorizedService.service = formGroup.controls.service.value;
      this.authorizedService.authorizationType = formGroup.controls.authorizationType.value;
      this.authorizedService.fedRampPackageId = formGroup.controls.fedRampPackageId.value;
      this.authorizedService.nature = formGroup.controls.nature.value;
      this.authorizedService.impactLevel = formGroup.controls.impactLevel.value;
      this.authorizedService.dataTypes = formGroup.controls.dataTypes.value;
      this.authorizedService.users = formGroup.controls.users.value;

      let authorizedServices = [...this.authorizedServices];
      if (this.newAuthorizedService)
        authorizedServices.push(this.authorizedService);
      else
        authorizedServices[
          this.authorizedServices.indexOf(
            this.selectedAuthorizedService
          )
          ] = this.authorizedService;

      this.authorizedServices = authorizedServices;
      this.authorizedService = null;

      this.displayAuthorizedServiceDialog = false;
    }
  }

  closeAuthorizedServiceDialog() {
    this.displayAuthorizedServiceDialog = false;
  }

  showDialogToAddExternalSystem() {
    const formGroup = this.formArray.get([31]) as FormGroup;
    formGroup.reset({
      number: '',
      name: '',
      isSupported: false,
      connectionDetails: '',
      nature: '',
      dataTypes: '',
      dataCategorization: '',
      users: '',
      otherPrograms: '',
      description: '',
      hostingEnvironment: '',
      riskImpactMitigation: '',
    });
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].setErrors(null);
    });
    this.newExternalSystem = true;
    this.externalSystem = new ExternalSystem();
    this.displayExternalSystemDialog = true;
  }

  editExternalSystem(item: ExternalSystem) {
    this.newExternalSystem = false;
    this.selectedExternalSystem = item;
    this.externalSystem = Object.assign({}, item);

    const externalSystemGroup = this.formArray.get([
      31
    ]) as FormGroup;
    externalSystemGroup.controls.number.setValue(item.number);
    externalSystemGroup.controls.name.setValue(item.name);
    externalSystemGroup.controls.connectionDetails.setValue(item.connectionDetails);
    externalSystemGroup.controls.nature.setValue(item.nature);
    externalSystemGroup.controls.isSupported.setValue(item.isSupported);
    externalSystemGroup.controls.dataTypes.setValue(item.dataTypes);
    externalSystemGroup.controls.dataCategorization.setValue(item.dataCategorization);
    externalSystemGroup.controls.users.setValue(item.users);
    externalSystemGroup.controls.otherPrograms.setValue(item.otherPrograms);
    externalSystemGroup.controls.description.setValue(item.description);
    externalSystemGroup.controls.hostingEnvironment.setValue(item.hostingEnvironment);
    externalSystemGroup.controls.riskImpactMitigation.setValue(item.riskImpactMitigation);

    this.displayExternalSystemDialog = true;
  }

  deleteExternalSystem(item) {
    let index = this.externalSystems.indexOf(item);
    this.externalSystems = this.externalSystems.filter(
      (val, i) => i != index
    );
    this.externalSystem = null;
  }

  saveExternalSystem() {
    const formGroup = this.formArray.get([31]) as FormGroup;
    if (formGroup.valid) {
      this.externalSystem.number = formGroup.controls.number.value;
      this.externalSystem.name = formGroup.controls.name.value;
      this.externalSystem.connectionDetails = formGroup.controls.connectionDetails.value;
      this.externalSystem.nature = formGroup.controls.nature.value;
      this.externalSystem.isSupported = formGroup.controls.isSupported.value;
      this.externalSystem.dataTypes = formGroup.controls.dataTypes.value;
      this.externalSystem.dataCategorization = formGroup.controls.dataCategorization.value;
      this.externalSystem.users = formGroup.controls.users.value;
      this.externalSystem.otherPrograms = formGroup.controls.otherPrograms.value;
      this.externalSystem.description = formGroup.controls.description.value;
      this.externalSystem.hostingEnvironment = formGroup.controls.hostingEnvironment.value;
      this.externalSystem.riskImpactMitigation = formGroup.controls.riskImpactMitigation.value;

      let externalSystems = [...this.externalSystems];
      if (this.newExternalSystem)
        externalSystems.push(this.externalSystem);
      else
        externalSystems[
          this.externalSystems.indexOf(
            this.selectedExternalSystem
          )
          ] = this.externalSystem;

      this.externalSystems = externalSystems;
      this.externalSystem = null;

      this.displayExternalSystemDialog = false;
    }
  }

  closeExternalSystemDialog() {
    this.displayExternalSystemDialog = false;
  }

  public addItProfileDocuments(event, field) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      this.clientProfileService
        .uploadAttachment(attachments[0])
        .subscribe((data) => {
          this[field] = attachments[0].name;
        });
    }
  }

  openFindings(result) {
    this.dialogService.open(InspectionResultsPopupComponent,
      {
        width: '50%',
        contentStyle: {overflow: 'auto'},
        baseZIndex: 10010,
        maximizable: true,
        data: {
          results: result.inspectionResults,
          allowDismiss: true
        }
      });
  }

  setReturnToProjectId() {
    var rememberedId = parseInt(
      window.localStorage.getItem('LastProjectVisited')
    );
    this.mappedProjects =
      this.projects.filter(
        (p) =>
          p.clientITProfileIds &&
          p.clientITProfileIds
            .split(';')
            .map((i) => parseInt(i))
            .indexOf(this.itProfile?.clientITProfileId) >= 0
      );
    this.returnToProjectId =
      !isNaN(rememberedId) &&
      rememberedId > 0 &&
      this.projects.find((p) => p.projectId == rememberedId)
        ? rememberedId
        : this.projects.find(
        (p) =>
          p.clientITProfileIds &&
          p.clientITProfileIds
            .split(';')
            .map((i) => parseInt(i))
            .indexOf(this.itProfile?.clientITProfileId) >= 0
      )?.projectId || null;
  }

  sign(separatedUser) {
    let config: MatDialogConfig = {
      data: {
      }
    };

    let dialogRef = this.dialog.open(AddSignatureComponent, config);

    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        separatedUser.signedName = data.name;
        separatedUser.signedDate = data.date;
        this.separatedUsers = [...this.separatedUsers];
        this.cdRef.detectChanges();
      }
    });
  }

  handleDiagram(diagram) {
    if (/\.(jpg|jpeg|png|gif|webp|svg|bmp)$/i.test(diagram.name)) {
      diagram.imageUrl = '/api/attachments/file?name=' + encodeURIComponent(diagram.internalName) + '&path=' + encodeURIComponent('Account/IT Profile/') + '&token=' + LoginHelper.getFileToken();
    }
    else {
      diagram.diagram3dUrls = [{
        url: '/api/attachments/file?name=' + encodeURIComponent(diagram.internalName) + '&path=' + encodeURIComponent('Account/IT Profile/') + '&token=' + LoginHelper.getFileToken(),
        file: diagram.internalName
      }];
    }
  }

  updateDefaultDiagram(diagram) {
    diagram.isDefault = true;
    this.diagrams.filter(d => d !== diagram).forEach(d => d.isDefault = false);
  }

  setDevicePosition(device) {
    let config: MatDialogConfig = {
      data: {
        device: device,
        diagrams: this.diagrams,
        devicePositions: device.devicePositions || []
      }
    };

    let dialogRef = this.dialog.open(SelectDiagramPositionComponent, config);

    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        device.devicePositions = data;
      }
    });
  }

  updateDeviceColumns() {
    this.devicesCols = [];
    if (!this.itProfile || this.itProfile.isDeviceNameVisible !== false) {
      this.devicesCols.push({
        field: 'deviceName',
        header: (this.itProfile || {}).deviceFieldNameDeviceName || 'Device Name'
      });
    }
    if (!this.itProfile || this.itProfile.isTypeVisible !== false) {
      this.devicesCols.push({field: 'type', header: (this.itProfile || {}).deviceFieldNameType || 'Type'});
    }
    if (!this.itProfile || this.itProfile.isManufacturerVisible !== false) {
      this.devicesCols.push({
        field: 'manufacturer',
        header: (this.itProfile || {}).deviceFieldNameManufacturer || 'Manufacturer'
      });
    }
    if (!this.itProfile || this.itProfile.isModelVisible !== false) {
      this.devicesCols.push({field: 'model', header: (this.itProfile || {}).deviceFieldNameModel || 'Model'});
    }
    if (!this.itProfile || this.itProfile.isSerialNumberVisible !== false) {
      this.devicesCols.push({
        field: 'serialNumber',
        header: (this.itProfile || {}).deviceFieldNameSerialNumber || 'Serial Number'
      });
    }
    if (!this.itProfile || this.itProfile.isIPVisible !== false) {
      this.devicesCols.push({field: 'ip', header: (this.itProfile || {}).deviceFieldNameIP || 'IP'});
    }
    if (!this.itProfile || this.itProfile.isMACVisible !== false) {
      this.devicesCols.push({field: 'mac', header: (this.itProfile || {}).deviceFieldNameMAC || 'MAC'});
    }
    if (!this.itProfile || this.itProfile.isPUIDVisible !== false) {
      this.devicesCols.push({field: 'puid', header: (this.itProfile || {}).deviceFieldNamePUID || 'PUID'});
    }
    if (!this.itProfile || this.itProfile.isOwnerVisible !== false) {
      this.devicesCols.push({field: 'owner', header: (this.itProfile || {}).deviceFieldNameOwner || 'Owner'});
    }
    if (!this.itProfile || this.itProfile.isLocationVisible !== false) {
      this.devicesCols.push({field: 'location', header: (this.itProfile || {}).deviceFieldNameLocation || 'Location'});
    }
  }

  protected readonly Role = Role;
}
